import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID3gxj6tk5isa35 as VOID,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  emptyList1g2z5xcrvp2zy as emptyList,
  LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  toString1pkumu07cwy4m as toString,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  IllegalArgumentException_init_$Create$3ewkh27kzt8z8 as IllegalArgumentException_init_$Create$,
  zip2suipyqmdw72q as zip,
  toMap1vec9topfei08 as toMap,
  LinkedHashMap_init_$Create$1f9mb1z5f3dxn as LinkedHashMap_init_$Create$,
  IllegalStateException_init_$Create$2w9444nebyjns as IllegalStateException_init_$Create$,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  LinkedHashMap_init_$Create$23uxki4opd0pn as LinkedHashMap_init_$Create$_0,
  KtMap140uvy3s5zad8 as KtMap,
  isInterface3d6p8outrmvmk as isInterface,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  captureStack1fzi4aczwc4hg as captureStack,
  IllegalArgumentException_init_$Init$1blytbdgl1fky as IllegalArgumentException_init_$Init$,
  IllegalArgumentException_init_$Init$1ke5df1bctk2y as IllegalArgumentException_init_$Init$_0,
  IllegalArgumentException_init_$Init$jyc1udwa6hs3 as IllegalArgumentException_init_$Init$_1,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  listOfvhqybd2zx248 as listOf,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$3bxttkj3v1mea as ArrayList_init_$Create$,
  _Result___get_value__impl__bjfvqg2ei4op8d4d2m as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpirivrr0d11rbi6gb as _Result___get_isFailure__impl__jpiriv,
  KClass1cc9rfeybg8hs as KClass,
  Triple1vhi3d0dgpnjb as Triple,
  getKClass3t8tygqu4lcxf as getKClass,
  Paire9pteg33gng7 as Pair,
  Entry2xmjmyutzoq3p as Entry,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  HashMap1a0ld5kgwhmhv as HashMap,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashSet2dzve9y63nf0v as HashSet,
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
  KtMutableList1beimitadwkna as KtMutableList,
  ArrayList3it5z8td81qkl as ArrayList,
  copyToArray2j022khrow2yi as copyToArray,
  Result3t1vadv16kmzk as Result,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  isBlank1dvkhjjvox3p0 as isBlank,
  toList383f556t1dixk as toList,
  ArrayList_init_$Create$149jv2ovkkvnt as ArrayList_init_$Create$_0,
  HashSet_init_$Create$3vvk876hypkbb as HashSet_init_$Create$,
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  toBooleanArray2u3qw7fjwsmuh as toBooleanArray,
  withIndex3s8q7w1g0hyfn as withIndex,
  to2cs3ny02qtbcb as to,
  lazy2hsh8ze7j6ikd as lazy_0,
  contentEqualsaf55p28mnw74 as contentEquals,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Char19o2r8palgjof as Char,
  Duration__toIsoString_impl_9h6wsm3b9pty5ms72ij as Duration__toIsoString_impl_9h6wsm,
  Duration5ynfiptaqcrg as Duration,
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  Instant2s2zyzgfc4947 as Instant,
  Companion_getInstance1jfygh5e58evr as Companion_getInstance_0,
  Uuid1zxgztb7abqxx as Uuid,
  Companion_getInstance1cdckxf15vkye as Companion_getInstance_1,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  hashCodeq5arwsb9dgti as hashCode,
  ArrayList_init_$Create$1k9mng94yui0r as ArrayList_init_$Create$_1,
  HashSet_init_$Create$2moxdurliew19 as HashSet_init_$Create$_0,
  LinkedHashSet_init_$Create$3o6z3oewjhki9 as LinkedHashSet_init_$Create$,
  LinkedHashSet_init_$Create$35d0fbehwrao9 as LinkedHashSet_init_$Create$_0,
  HashMap_init_$Create$2pprpqyxxsq9t as HashMap_init_$Create$,
  HashMap_init_$Create$b8oqvbb9c2yv as HashMap_init_$Create$_0,
  LinkedHashMap_init_$Create$jfk1f3iu2ll6 as LinkedHashMap_init_$Create$_1,
  isArray1hxjqtqy632bc as isArray,
  arrayIterator3lgwvgteckzhv as arrayIterator,
  asList2ho2pewtsfvv as asList,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  getValue48kllevslyh6 as getValue,
  longArray288a0fctlmjmj as longArray,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get_lastIndex1y2f6o9u8hnf7 as get_lastIndex,
  shiftLeft3tsh2sstjchzn as shiftLeft,
  countTrailingZeroBits1k55x07cygoff as countTrailingZeroBits,
  getOrNull1d60i0672n7ns as getOrNull,
  indexOf3ic8eacwbbrog as indexOf,
  contentToString3ujacv8hqfipd as contentToString,
  Enum3alwj03lh1n41 as Enum,
  joinToString1cxrrlmo0chqs as joinToString,
  toString30pk9tzaqopn as toString_0,
  KTypeParameter1s8efufd4mbj5 as KTypeParameter,
  HashSet_init_$Create$1almu45bw06ne as HashSet_init_$Create$_1,
  booleanArray2jdug9b51huk7 as booleanArray,
  emptyMapr06gerzljqtm as emptyMap,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  Companion_getInstance2e3h8n26rh23 as Companion_getInstance_2,
  isCharArray21auq5hbrg68m as isCharArray,
  charArray2ujmm1qusno00 as charArray,
  DoubleCompanionObject_instance3q51gr7gsd0au as DoubleCompanionObject_instance,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  FloatCompanionObject_instance367t6x2s4xzmv as FloatCompanionObject_instance,
  isFloatArrayjjscnqphw92j as isFloatArray,
  Companion_instance3skn40jhkoxyn as Companion_instance,
  isLongArray2fdt3z7yu3ef as isLongArray,
  Companion_getInstance1puqqwzccfvrg as Companion_getInstance_3,
  _ULongArray___get_size__impl__ju6dtr2cm0h8pvj33oc as _ULongArray___get_size__impl__ju6dtr,
  ULongArray3nd0d80mdwjj8 as ULongArray,
  _ULongArray___init__impl__twm1l318nadwrsl904i as _ULongArray___init__impl__twm1l3,
  _ULong___init__impl__c78o9k1p6qzv0dh0bvg as _ULong___init__impl__c78o9k,
  ULongArray__get_impl_pr71q9ba20e4znze0l as ULongArray__get_impl_pr71q9,
  _ULong___get_data__impl__fggpzb2qlkrfp9zs48z as _ULong___get_data__impl__fggpzb,
  IntCompanionObject_instance3tw56cgyd5vup as IntCompanionObject_instance,
  isIntArrayeijsubfngq38 as isIntArray,
  Companion_getInstanceuedpedmz4g65 as Companion_getInstance_4,
  _UIntArray___get_size__impl__r6l8ci2fqw6ae893py3 as _UIntArray___get_size__impl__r6l8ci,
  UIntArrayrp6cv44n5v4y as UIntArray,
  _UIntArray___init__impl__ghjpc618b75h631neq9 as _UIntArray___init__impl__ghjpc6,
  _UInt___init__impl__l7qpdltd1eeof8nsuj as _UInt___init__impl__l7qpdl,
  UIntArray__get_impl_gp5kza2hxcr782v503s as UIntArray__get_impl_gp5kza,
  _UInt___get_data__impl__f0vqqw13y1a2xkii3dn as _UInt___get_data__impl__f0vqqw,
  ShortCompanionObject_instance3vq120mx8545m as ShortCompanionObject_instance,
  isShortArraywz30zxwtqi8h as isShortArray,
  Companion_getInstance2du03jiluw9jj as Companion_getInstance_5,
  _UShortArray___get_size__impl__jqto1b1rcopfj002me5 as _UShortArray___get_size__impl__jqto1b,
  UShortArray11avpmknxdgvv as UShortArray,
  _UShortArray___init__impl__9b26ef2aumgbpdmuy5g as _UShortArray___init__impl__9b26ef,
  _UShort___init__impl__jigrne2jag2u7194ozm as _UShort___init__impl__jigrne,
  UShortArray__get_impl_fnbhmx31xgjirit34wn as UShortArray__get_impl_fnbhmx,
  _UShort___get_data__impl__g0245hlms5v6vgvnl as _UShort___get_data__impl__g0245,
  ByteCompanionObject_instance9rvhjp0l184i as ByteCompanionObject_instance,
  isByteArray4nnzfn1x4o3w as isByteArray,
  Companion_getInstance1trnkq9cty7vr as Companion_getInstance_6,
  _UByteArray___get_size__impl__h6pkdv1cve284ztupz4 as _UByteArray___get_size__impl__h6pkdv,
  UByteArray2qu4d6gwssdf9 as UByteArray,
  _UByteArray___init__impl__ip4y9n23n7lz0x7gq72 as _UByteArray___init__impl__ip4y9n,
  _UByte___init__impl__g9hnc43ude1dscg1q30 as _UByte___init__impl__g9hnc4,
  UByteArray__get_impl_t5f3hvz1l7xhrol2kb as UByteArray__get_impl_t5f3hv,
  _UByte___get_data__impl__jof9qr2p2xx2i2jvnz8 as _UByte___get_data__impl__jof9qr,
  BooleanCompanionObject_instance29o5h9ajgjmec as BooleanCompanionObject_instance,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  copyOf2p23ljc5f5ea3 as copyOf,
  copyOfgossjg6lh6js as copyOf_0,
  copyOfq9pcgcgbldck as copyOf_1,
  copyOf9mbsebmgnw4t as copyOf_2,
  _ULongArray___get_storage__impl__28e64jd93r4nwx0bzi as _ULongArray___get_storage__impl__28e64j,
  _ULongArray___init__impl__twm1l310ecgw67nsok9 as _ULongArray___init__impl__twm1l3_0,
  ULongArray__set_impl_z19mvh2wf37xvulocfs as ULongArray__set_impl_z19mvh,
  copyOf3rutauicler23 as copyOf_3,
  _UIntArray___get_storage__impl__92a0v02db5qclx33scp as _UIntArray___get_storage__impl__92a0v0,
  _UIntArray___init__impl__ghjpc617c61a9kgqgj3 as _UIntArray___init__impl__ghjpc6_0,
  UIntArray__set_impl_7f2zu21rg83h8k5rr6q as UIntArray__set_impl_7f2zu2,
  copyOf39s58md6y6rn6 as copyOf_4,
  _UShortArray___get_storage__impl__t2jpv516i6vr5ztry4u as _UShortArray___get_storage__impl__t2jpv5,
  _UShortArray___init__impl__9b26ef3ghkk09gj85t3 as _UShortArray___init__impl__9b26ef_0,
  UShortArray__set_impl_6d8whp1o84pp60fh8tm as UShortArray__set_impl_6d8whp,
  copyOfwy6h3t5vzqpl as copyOf_5,
  _UByteArray___get_storage__impl__d4kctt25iva2n6yox0m as _UByteArray___get_storage__impl__d4kctt,
  _UByteArray___init__impl__ip4y9ndqanl1uze050 as _UByteArray___init__impl__ip4y9n_0,
  UByteArray__set_impl_jvcicnym486up0f2lk as UByteArray__set_impl_jvcicn,
  copyOf37mht4mx7mjgh as copyOf_6,
  trimIndent1qytc1wvt8suh as trimIndent,
  Unitkvevlwgzwiuc as Unit,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  get_lastIndex1yw0x4k50k51w as get_lastIndex_0,
  ULong3f9k7s38t3rfp as ULong,
  UInt1hthisrv6cndi as UInt,
  UBytep4j7r1t64gz1 as UByte,
  UShort26xnqty60t7le as UShort,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  get_js1ale1wr4fbvs0 as get_js,
  PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance,
  findAssociatedObject1kb88g16k1goa as findAssociatedObject,
  get_indicesc04v40g017hw as get_indices,
  IndexOutOfBoundsException_init_$Create$2w5dv25cjssuw as IndexOutOfBoundsException_init_$Create$,
  get_indices377latqcai313 as get_indices_0,
  mapOf1xd03cq9cnmy8 as mapOf,
  Companion_instance2oawqq9qiaris as Companion_instance_0,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForInterface(SerializationStrategy, 'SerializationStrategy');
initMetadataForInterface(DeserializationStrategy, 'DeserializationStrategy');
initMetadataForInterface(KSerializer, 'KSerializer', VOID, VOID, [SerializationStrategy, DeserializationStrategy]);
initMetadataForClass(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(PolymorphicSerializer, 'PolymorphicSerializer', VOID, AbstractPolymorphicSerializer);
initMetadataForClass(SealedClassSerializer$$inlined$groupingBy$1);
initMetadataForClass(SealedClassSerializer, 'SealedClassSerializer', VOID, AbstractPolymorphicSerializer);
initMetadataForInterface(StringFormat, 'StringFormat');
initMetadataForInterface(BinaryFormat, 'BinaryFormat');
initMetadataForClass(SerializationException, 'SerializationException', SerializationException_init_$Create$, IllegalArgumentException);
initMetadataForClass(UnknownFieldException, 'UnknownFieldException', VOID, SerializationException);
initMetadataForClass(MissingFieldException, 'MissingFieldException', VOID, SerializationException);
function get_isNullable() {
  return false;
}
function get_isInline() {
  return false;
}
function get_annotations() {
  return emptyList();
}
initMetadataForInterface(SerialDescriptor, 'SerialDescriptor');
initMetadataForClass(ContextDescriptor, 'ContextDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(elementNames$1);
initMetadataForClass(elementNames$$inlined$Iterable$1);
initMetadataForClass(elementDescriptors$1);
initMetadataForClass(elementDescriptors$$inlined$Iterable$1);
initMetadataForClass(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder');
initMetadataForInterface(CachedNames, 'CachedNames');
initMetadataForClass(SerialDescriptorImpl, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(SerialKind, 'SerialKind');
initMetadataForClass(PrimitiveKind, 'PrimitiveKind', VOID, SerialKind);
initMetadataForObject(BOOLEAN, 'BOOLEAN', VOID, PrimitiveKind);
initMetadataForObject(BYTE, 'BYTE', VOID, PrimitiveKind);
initMetadataForObject(CHAR, 'CHAR', VOID, PrimitiveKind);
initMetadataForObject(SHORT, 'SHORT', VOID, PrimitiveKind);
initMetadataForObject(INT, 'INT', VOID, PrimitiveKind);
initMetadataForObject(LONG, 'LONG', VOID, PrimitiveKind);
initMetadataForObject(FLOAT, 'FLOAT', VOID, PrimitiveKind);
initMetadataForObject(DOUBLE, 'DOUBLE', VOID, PrimitiveKind);
initMetadataForObject(STRING, 'STRING', VOID, PrimitiveKind);
initMetadataForClass(PolymorphicKind, 'PolymorphicKind', VOID, SerialKind);
initMetadataForObject(SEALED, 'SEALED', VOID, PolymorphicKind);
initMetadataForObject(OPEN, 'OPEN', VOID, PolymorphicKind);
initMetadataForObject(ENUM, 'ENUM', VOID, SerialKind);
initMetadataForObject(CONTEXTUAL, 'CONTEXTUAL', VOID, SerialKind);
initMetadataForClass(StructureKind, 'StructureKind', VOID, SerialKind);
initMetadataForObject(CLASS, 'CLASS', VOID, StructureKind);
initMetadataForObject(LIST, 'LIST', VOID, StructureKind);
initMetadataForObject(MAP, 'MAP', VOID, StructureKind);
initMetadataForObject(OBJECT, 'OBJECT', VOID, StructureKind);
function decodeSerializableValue(deserializer) {
  return deserializer.hp(this);
}
initMetadataForInterface(Decoder, 'Decoder');
function decodeSequentially() {
  return false;
}
function decodeCollectionSize(descriptor) {
  return -1;
}
function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
  previousValue = previousValue === VOID ? null : previousValue;
  return $super === VOID ? this.et(descriptor, index, deserializer, previousValue) : $super.et.call(this, descriptor, index, deserializer, previousValue);
}
initMetadataForInterface(CompositeDecoder, 'CompositeDecoder');
initMetadataForClass(AbstractDecoder, 'AbstractDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
function encodeNotNullMark() {
}
function beginCollection(descriptor, collectionSize) {
  return this.ss(descriptor);
}
function encodeSerializableValue(serializer, value) {
  serializer.gp(this, value);
}
function encodeNullableSerializableValue(serializer, value) {
  var isNullabilitySupported = serializer.fp().sq();
  if (isNullabilitySupported) {
    return this.ku(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
  }
  if (value == null) {
    this.nt();
  } else {
    this.nu();
    this.ku(serializer, value);
  }
}
initMetadataForInterface(Encoder, 'Encoder');
function shouldEncodeElementDefault(descriptor, index) {
  return true;
}
initMetadataForInterface(CompositeEncoder, 'CompositeEncoder');
initMetadataForClass(AbstractEncoder, 'AbstractEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
initMetadataForObject(NothingSerializer_0, 'NothingSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DurationSerializer, 'DurationSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(InstantSerializer, 'InstantSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UuidSerializer, 'UuidSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(ListLikeDescriptor, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(ArrayListClassDesc, 'ArrayListClassDesc', VOID, ListLikeDescriptor);
initMetadataForClass(HashSetClassDesc, 'HashSetClassDesc', VOID, ListLikeDescriptor);
initMetadataForClass(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc', VOID, ListLikeDescriptor);
initMetadataForClass(MapLikeDescriptor, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(HashMapClassDesc, 'HashMapClassDesc', VOID, MapLikeDescriptor);
initMetadataForClass(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc', VOID, MapLikeDescriptor);
initMetadataForClass(ArrayClassDesc, 'ArrayClassDesc', VOID, ListLikeDescriptor);
initMetadataForClass(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor', VOID, ListLikeDescriptor);
initMetadataForClass(AbstractCollectionSerializer, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(CollectionLikeSerializer, 'CollectionLikeSerializer', VOID, AbstractCollectionSerializer);
initMetadataForClass(CollectionSerializer, 'CollectionSerializer', VOID, CollectionLikeSerializer);
initMetadataForClass(ArrayListSerializer, 'ArrayListSerializer', VOID, CollectionSerializer);
initMetadataForClass(HashSetSerializer, 'HashSetSerializer', VOID, CollectionSerializer);
initMetadataForClass(LinkedHashSetSerializer, 'LinkedHashSetSerializer', VOID, CollectionSerializer);
initMetadataForClass(MapLikeSerializer, 'MapLikeSerializer', VOID, AbstractCollectionSerializer);
initMetadataForClass(HashMapSerializer, 'HashMapSerializer', VOID, MapLikeSerializer);
initMetadataForClass(LinkedHashMapSerializer, 'LinkedHashMapSerializer', VOID, MapLikeSerializer);
initMetadataForClass(ReferenceArraySerializer, 'ReferenceArraySerializer', VOID, CollectionLikeSerializer);
initMetadataForClass(PrimitiveArraySerializer, 'PrimitiveArraySerializer', VOID, CollectionLikeSerializer);
initMetadataForClass(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder');
initMetadataForCompanion(Companion);
initMetadataForClass(ElementMarker, 'ElementMarker');
initMetadataForClass(EnumSerializer, 'EnumSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(EnumDescriptor, 'EnumDescriptor', VOID, PluginGeneratedSerialDescriptor);
initMetadataForClass(InlineClassDescriptor, 'InlineClassDescriptor', VOID, PluginGeneratedSerialDescriptor);
function typeParametersSerializers() {
  return get_EMPTY_SERIALIZER_ARRAY();
}
initMetadataForInterface(GeneratedSerializer, 'GeneratedSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(InlinePrimitiveDescriptor$1, VOID, VOID, VOID, [GeneratedSerializer]);
initMetadataForObject(NoOpEncoder, 'NoOpEncoder', VOID, AbstractEncoder);
initMetadataForObject(NothingSerialDescriptor, 'NothingSerialDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(NullableSerializer, 'NullableSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(SerialDescriptorForNullable, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(ObjectSerializer, 'ObjectSerializer', VOID, VOID, [KSerializer]);
initMetadataForInterface(SerializerFactory, 'SerializerFactory');
initMetadataForObject(CharArraySerializer_0, 'CharArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(DoubleArraySerializer_0, 'DoubleArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(FloatArraySerializer_0, 'FloatArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(LongArraySerializer_0, 'LongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ULongArraySerializer_0, 'ULongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(IntArraySerializer_0, 'IntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UIntArraySerializer_0, 'UIntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ShortArraySerializer_0, 'ShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UShortArraySerializer_0, 'UShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ByteArraySerializer_0, 'ByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UByteArraySerializer_0, 'UByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(BooleanArraySerializer_0, 'BooleanArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
initMetadataForClass(CharArrayBuilder, 'CharArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(DoubleArrayBuilder, 'DoubleArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(FloatArrayBuilder, 'FloatArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(LongArrayBuilder, 'LongArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(ULongArrayBuilder, 'ULongArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(IntArrayBuilder, 'IntArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(UIntArrayBuilder, 'UIntArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(ShortArrayBuilder, 'ShortArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(UShortArrayBuilder, 'UShortArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(UByteArrayBuilder, 'UByteArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForClass(BooleanArrayBuilder, 'BooleanArrayBuilder', VOID, PrimitiveArrayBuilder);
initMetadataForObject(LongSerializer, 'LongSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(StringSerializer, 'StringSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(BooleanSerializer, 'BooleanSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(IntSerializer, 'IntSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(FloatSerializer, 'FloatSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(PrimitiveSerialDescriptor_0, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(ByteSerializer, 'ByteSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ShortSerializer, 'ShortSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(CharSerializer, 'CharSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DoubleSerializer, 'DoubleSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UnitSerializer, 'UnitSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(TaggedDecoder, 'TaggedDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForClass(NamedValueDecoder, 'NamedValueDecoder', VOID, TaggedDecoder);
initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
initMetadataForClass(KeyValueSerializer, 'KeyValueSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(MapEntrySerializer_0, 'MapEntrySerializer', VOID, KeyValueSerializer);
initMetadataForClass(PairSerializer_0, 'PairSerializer', VOID, KeyValueSerializer);
initMetadataForClass(TripleSerializer_0, 'TripleSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ULongSerializer, 'ULongSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UIntSerializer, 'UIntSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UByteSerializer, 'UByteSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UShortSerializer, 'UShortSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(SerializersModule, 'SerializersModule');
initMetadataForClass(SerialModuleImpl, 'SerialModuleImpl', VOID, SerializersModule);
initMetadataForClass(ContextualProvider, 'ContextualProvider');
initMetadataForClass(Argless, 'Argless', VOID, ContextualProvider);
initMetadataForClass(WithTypeArguments, 'WithTypeArguments', VOID, ContextualProvider);
function contextual(kClass, serializer) {
  return this.m19(kClass, SerializersModuleCollector$contextual$lambda(serializer));
}
initMetadataForInterface(SerializersModuleCollector, 'SerializersModuleCollector');
initMetadataForClass(SerializableWith, 'SerializableWith', VOID, VOID, VOID, VOID, 0);
initMetadataForClass(createCache$1);
initMetadataForClass(createParametrizedCache$1);
//endregion
function KSerializer() {
}
function DeserializationStrategy() {
}
function SerializationStrategy() {
}
function findPolymorphicSerializer(_this__u8e3s4, decoder, klassName) {
  var tmp0_elvis_lhs = _this__u8e3s4.ip(decoder, klassName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered(klassName, _this__u8e3s4.jp());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function findPolymorphicSerializer_0(_this__u8e3s4, encoder, value) {
  var tmp0_elvis_lhs = _this__u8e3s4.kp(encoder, value);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered_0(getKClassFromExpression(value), _this__u8e3s4.jp());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.tp('type', serializer_2(StringCompanionObject_instance).fp());
    $this$buildSerialDescriptor.tp('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.up_1.ea() + '>', CONTEXTUAL_getInstance(), []));
    $this$buildSerialDescriptor.np_1 = this$0.vp_1;
    return Unit_instance;
  };
}
function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
  return function () {
    var tmp = OPEN_getInstance();
    return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.up_1);
  };
}
function PolymorphicSerializer$_get_descriptor_$ref_8tw9if() {
  return function (p0) {
    return p0.fp();
  };
}
function PolymorphicSerializer(baseClass) {
  AbstractPolymorphicSerializer.call(this);
  this.up_1 = baseClass;
  this.vp_1 = emptyList();
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.wp_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
}
protoOf(PolymorphicSerializer).jp = function () {
  return this.up_1;
};
protoOf(PolymorphicSerializer).fp = function () {
  var tmp0 = this.wp_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('descriptor', 1, tmp, PolymorphicSerializer$_get_descriptor_$ref_8tw9if(), null);
  return tmp0.w();
};
protoOf(PolymorphicSerializer).toString = function () {
  return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString(this.up_1) + ')';
};
function SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this$0.cq_1.u().l();
    while (_iterator__ex2g4s.m()) {
      var element = _iterator__ex2g4s.n();
      // Inline function 'kotlin.collections.component1' call
      var name = element.v();
      // Inline function 'kotlin.collections.component2' call
      var serializer = element.w();
      $this$buildSerialDescriptor.tp(name, serializer.fp());
    }
    return Unit_instance;
  };
}
function SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.tp('type', serializer_2(StringCompanionObject_instance).fp());
    var tmp = 'kotlinx.serialization.Sealed<' + this$0.yp_1.ea() + '>';
    var tmp_0 = CONTEXTUAL_getInstance();
    var elementDescriptor = buildSerialDescriptor(tmp, tmp_0, [], SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0));
    $this$buildSerialDescriptor.tp('value', elementDescriptor);
    $this$buildSerialDescriptor.np_1 = this$0.zp_1;
    return Unit_instance;
  };
}
function SealedClassSerializer$descriptor$delegate$lambda($serialName, this$0) {
  return function () {
    var tmp = SEALED_getInstance();
    return buildSerialDescriptor($serialName, tmp, [], SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0));
  };
}
function SealedClassSerializer$_get_descriptor_$ref_m511rz() {
  return function (p0) {
    return p0.fp();
  };
}
function SealedClassSerializer$$inlined$groupingBy$1($this) {
  this.dq_1 = $this;
}
protoOf(SealedClassSerializer$$inlined$groupingBy$1).eq = function () {
  return this.dq_1.l();
};
protoOf(SealedClassSerializer$$inlined$groupingBy$1).fq = function (element) {
  return element.w().fp().gq();
};
protoOf(SealedClassSerializer$$inlined$groupingBy$1).hq = function (element) {
  return this.fq((element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function SealedClassSerializer(serialName, baseClass, subclasses, subclassSerializers) {
  AbstractPolymorphicSerializer.call(this);
  this.yp_1 = baseClass;
  this.zp_1 = emptyList();
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.aq_1 = lazy(tmp_0, SealedClassSerializer$descriptor$delegate$lambda(serialName, this));
  if (!(subclasses.length === subclassSerializers.length)) {
    throw IllegalArgumentException_init_$Create$('All subclasses of sealed class ' + this.yp_1.ea() + ' should be marked @Serializable');
  }
  this.bq_1 = toMap(zip(subclasses, subclassSerializers));
  var tmp_1 = this;
  // Inline function 'kotlin.collections.groupingBy' call
  var this_0 = this.bq_1.u();
  // Inline function 'kotlin.collections.aggregate' call
  var tmp0 = new SealedClassSerializer$$inlined$groupingBy$1(this_0);
  // Inline function 'kotlin.collections.mutableMapOf' call
  // Inline function 'kotlin.collections.aggregateTo' call
  var destination = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = tmp0.eq();
  while (_iterator__ex2g4s.m()) {
    var e = _iterator__ex2g4s.n();
    var key = tmp0.hq(e);
    var accumulator = destination.h2(key);
    accumulator == null && !destination.f2(key);
    if (!(accumulator == null)) {
      // Inline function 'kotlin.error' call
      var message = "Multiple sealed subclasses of '" + toString(this.yp_1) + "' have the same serial name '" + key + "':" + (" '" + toString(accumulator.v()) + "', '" + toString(e.v()) + "'");
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.collections.set' call
    destination.a2(key, e);
  }
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination_0 = LinkedHashMap_init_$Create$_0(mapCapacity(destination.o()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_0 = destination.u().l();
  while (_iterator__ex2g4s_0.m()) {
    var element = _iterator__ex2g4s_0.n();
    var tmp_2 = element.v();
    var tmp$ret$8 = element.w().w();
    destination_0.a2(tmp_2, tmp$ret$8);
  }
  tmp_1.cq_1 = destination_0;
}
protoOf(SealedClassSerializer).jp = function () {
  return this.yp_1;
};
protoOf(SealedClassSerializer).fp = function () {
  var tmp0 = this.aq_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('descriptor', 1, tmp, SealedClassSerializer$_get_descriptor_$ref_m511rz(), null);
  return tmp0.w();
};
protoOf(SealedClassSerializer).ip = function (decoder, klassName) {
  // Inline function 'kotlin.collections.get' call
  var this_0 = this.cq_1;
  var tmp0_elvis_lhs = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).h2(klassName);
  return tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).ip.call(this, decoder, klassName) : tmp0_elvis_lhs;
};
protoOf(SealedClassSerializer).kp = function (encoder, value) {
  var tmp0_elvis_lhs = this.bq_1.h2(getKClassFromExpression(value));
  var tmp1_safe_receiver = tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).kp.call(this, encoder, value) : tmp0_elvis_lhs;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp = isInterface(tmp1_safe_receiver, SerializationStrategy) ? tmp1_safe_receiver : THROW_CCE();
  }
  return tmp;
};
function StringFormat() {
}
function BinaryFormat() {
}
function UnknownFieldException_init_$Init$(index, $this) {
  UnknownFieldException.call($this, 'An unknown field for index ' + index);
  return $this;
}
function UnknownFieldException_init_$Create$(index) {
  var tmp = UnknownFieldException_init_$Init$(index, objectCreate(protoOf(UnknownFieldException)));
  captureStack(tmp, UnknownFieldException_init_$Create$);
  return tmp;
}
function UnknownFieldException(message) {
  SerializationException_init_$Init$_0(message, this);
  captureStack(this, UnknownFieldException);
}
function SerializationException_init_$Init$($this) {
  IllegalArgumentException_init_$Init$($this);
  SerializationException.call($this);
  return $this;
}
function SerializationException_init_$Create$() {
  var tmp = SerializationException_init_$Init$(objectCreate(protoOf(SerializationException)));
  captureStack(tmp, SerializationException_init_$Create$);
  return tmp;
}
function SerializationException_init_$Init$_0(message, $this) {
  IllegalArgumentException_init_$Init$_0(message, $this);
  SerializationException.call($this);
  return $this;
}
function SerializationException_init_$Create$_0(message) {
  var tmp = SerializationException_init_$Init$_0(message, objectCreate(protoOf(SerializationException)));
  captureStack(tmp, SerializationException_init_$Create$_0);
  return tmp;
}
function SerializationException_init_$Init$_1(message, cause, $this) {
  IllegalArgumentException_init_$Init$_1(message, cause, $this);
  SerializationException.call($this);
  return $this;
}
function SerializationException() {
  captureStack(this, SerializationException);
}
function MissingFieldException_init_$Init$(missingFields, serialName, $this) {
  MissingFieldException.call($this, missingFields, missingFields.o() === 1 ? "Field '" + missingFields.p(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing", null);
  return $this;
}
function MissingFieldException_init_$Create$(missingFields, serialName) {
  var tmp = MissingFieldException_init_$Init$(missingFields, serialName, objectCreate(protoOf(MissingFieldException)));
  captureStack(tmp, MissingFieldException_init_$Create$);
  return tmp;
}
function MissingFieldException_init_$Init$_0(missingField, serialName, $this) {
  MissingFieldException.call($this, listOf(missingField), "Field '" + missingField + "' is required for type with serial name '" + serialName + "', but it was missing", null);
  return $this;
}
function MissingFieldException_init_$Create$_0(missingField, serialName) {
  var tmp = MissingFieldException_init_$Init$_0(missingField, serialName, objectCreate(protoOf(MissingFieldException)));
  captureStack(tmp, MissingFieldException_init_$Create$_0);
  return tmp;
}
function MissingFieldException(missingFields, message, cause) {
  SerializationException_init_$Init$_1(message, cause, this);
  captureStack(this, MissingFieldException);
  this.mq_1 = missingFields;
}
function serializerOrNull(_this__u8e3s4) {
  var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
  return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
}
function serializer(_this__u8e3s4, type) {
  var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    platformSpecificSerializerNotRegistered(kclass(type));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
  var rootClass = kclass(type);
  var isNullable = type.ua();
  // Inline function 'kotlin.collections.map' call
  var this_0 = type.ta();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.l();
  while (_iterator__ex2g4s.m()) {
    var item = _iterator__ex2g4s.n();
    var tmp$ret$0 = typeOrThrow(item);
    destination.j(tmp$ret$0);
  }
  var typeArguments = destination;
  var tmp;
  if (typeArguments.q()) {
    var tmp_0;
    if (isInterface_0(rootClass) && !(_this__u8e3s4.oq(rootClass) == null)) {
      tmp_0 = null;
    } else {
      tmp_0 = findCachedSerializer(rootClass, isNullable);
    }
    tmp = tmp_0;
  } else {
    var tmp_1;
    if (_this__u8e3s4.nq()) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.Result.getOrNull' call
      var this_1 = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
      var tmp_2;
      if (_Result___get_isFailure__impl__jpiriv(this_1)) {
        tmp_2 = null;
      } else {
        var tmp_3 = _Result___get_value__impl__bjfvqg(this_1);
        tmp_2 = (tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE();
      }
      tmp_1 = tmp_2;
    }
    tmp = tmp_1;
  }
  var cachedSerializer = tmp;
  if (!(cachedSerializer == null))
    return cachedSerializer;
  var tmp_4;
  if (typeArguments.q()) {
    var tmp0_elvis_lhs = serializerOrNull(rootClass);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? _this__u8e3s4.oq(rootClass) : tmp0_elvis_lhs;
    var tmp_5;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_5 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
    } else {
      tmp_5 = tmp1_elvis_lhs;
    }
    tmp_4 = tmp_5;
  } else {
    var tmp2_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
    var tmp_6;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_6 = tmp2_elvis_lhs;
    }
    var serializers = tmp_6;
    var tmp3_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
    var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? _this__u8e3s4.pq(rootClass, serializers) : tmp3_elvis_lhs;
    var tmp_7;
    if (tmp4_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_7 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
    } else {
      tmp_7 = tmp4_elvis_lhs;
    }
    tmp_4 = tmp_7;
  }
  var contextualSerializer = tmp_4;
  var tmp_8;
  if (contextualSerializer == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_8 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
  }
  var tmp6_safe_receiver = tmp_8;
  return tmp6_safe_receiver == null ? null : nullable(tmp6_safe_receiver, isNullable);
}
function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
  var tmp;
  if (failOnMissingTypeArgSerializer) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
    var _iterator__ex2g4s = typeArguments.l();
    while (_iterator__ex2g4s.m()) {
      var item = _iterator__ex2g4s.n();
      var tmp$ret$0 = serializer(_this__u8e3s4, item);
      destination.j(tmp$ret$0);
    }
    tmp = destination;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
    var _iterator__ex2g4s_0 = typeArguments.l();
    while (_iterator__ex2g4s_0.m()) {
      var item_0 = _iterator__ex2g4s_0.n();
      var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp$ret$3 = tmp_0;
      destination_0.j(tmp$ret$3);
    }
    tmp = destination_0;
  }
  var serializers = tmp;
  return serializers;
}
function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
  return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
}
function nullable(_this__u8e3s4, shouldBeNullable) {
  if (shouldBeNullable)
    return get_nullable(_this__u8e3s4);
  return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
}
function serializerOrNull_0(_this__u8e3s4, type) {
  return serializerByKTypeImpl(_this__u8e3s4, type, false);
}
function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp;
  if (_this__u8e3s4.equals(getKClass(Collection)) || _this__u8e3s4.equals(getKClass(KtList)) || (_this__u8e3s4.equals(getKClass(KtMutableList)) || _this__u8e3s4.equals(getKClass(ArrayList)))) {
    tmp = new ArrayListSerializer(serializers.p(0));
  } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
    tmp = new HashSetSerializer(serializers.p(0));
  } else if (_this__u8e3s4.equals(getKClass(KtSet)) || (_this__u8e3s4.equals(getKClass(KtMutableSet)) || _this__u8e3s4.equals(getKClass(LinkedHashSet)))) {
    tmp = new LinkedHashSetSerializer(serializers.p(0));
  } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
    tmp = new HashMapSerializer(serializers.p(0), serializers.p(1));
  } else if (_this__u8e3s4.equals(getKClass(KtMap)) || (_this__u8e3s4.equals(getKClass(KtMutableMap)) || _this__u8e3s4.equals(getKClass(LinkedHashMap)))) {
    tmp = new LinkedHashMapSerializer(serializers.p(0), serializers.p(1));
  } else if (_this__u8e3s4.equals(getKClass(Entry))) {
    tmp = MapEntrySerializer(serializers.p(0), serializers.p(1));
  } else if (_this__u8e3s4.equals(getKClass(Pair))) {
    tmp = PairSerializer(serializers.p(0), serializers.p(1));
  } else if (_this__u8e3s4.equals(getKClass(Triple))) {
    tmp = TripleSerializer(serializers.p(0), serializers.p(1), serializers.p(2));
  } else {
    var tmp_0;
    if (isReferenceArray(_this__u8e3s4)) {
      var tmp_1 = elementClassifierIfArray();
      tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.p(0));
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$0 = copyToArray(serializers);
  return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
}
function serializer_0(type) {
  return serializer(EmptySerializersModule_0(), type);
}
function serializer_1(_this__u8e3s4) {
  var tmp0_elvis_lhs = serializerOrNull(_this__u8e3s4);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    serializerNotRegistered(_this__u8e3s4);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function serializerByKTypeImpl$lambda($typeArguments) {
  return function () {
    return $typeArguments.p(0).sa();
  };
}
function get_SERIALIZERS_CACHE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return SERIALIZERS_CACHE;
}
var SERIALIZERS_CACHE;
function get_SERIALIZERS_CACHE_NULLABLE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return SERIALIZERS_CACHE_NULLABLE;
}
var SERIALIZERS_CACHE_NULLABLE;
function get_PARAMETRIZED_SERIALIZERS_CACHE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return PARAMETRIZED_SERIALIZERS_CACHE;
}
var PARAMETRIZED_SERIALIZERS_CACHE;
function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
}
var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
function findCachedSerializer(clazz, isNullable) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp;
  if (!isNullable) {
    var tmp0_safe_receiver = get_SERIALIZERS_CACHE().qq(clazz);
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_0 = isInterface(tmp0_safe_receiver, KSerializer) ? tmp0_safe_receiver : THROW_CCE();
    }
    tmp = tmp_0;
  } else {
    tmp = get_SERIALIZERS_CACHE_NULLABLE().qq(clazz);
  }
  return tmp;
}
function findParametrizedCachedSerializer(clazz, types, isNullable) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp;
  if (!isNullable) {
    var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().rq(clazz, types);
    tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
  } else {
    tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().rq(clazz, types);
  }
  return tmp;
}
function SERIALIZERS_CACHE$lambda(it) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp0_elvis_lhs = serializerOrNull(it);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
    tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp0_elvis_lhs = serializerOrNull(it);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
    tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp1_safe_receiver = tmp;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_nullable(tmp1_safe_receiver);
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_0 = isInterface(tmp2_safe_receiver, KSerializer) ? tmp2_safe_receiver : THROW_CCE();
  }
  return tmp_0;
}
function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
  return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
}
function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
  return function () {
    return $types.p(0).sa();
  };
}
function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
  var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
  }
  return tmp;
}
function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
  return function () {
    return $types.p(0).sa();
  };
}
var properties_initialized_SerializersCache_kt_q8kf25;
function _init_properties_SerializersCache_kt__hgwi2p() {
  if (!properties_initialized_SerializersCache_kt_q8kf25) {
    properties_initialized_SerializersCache_kt_q8kf25 = true;
    SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
    SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
    PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
    PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
  }
}
function get_nullable(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.fp().sq()) {
    tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  } else {
    tmp = new NullableSerializer(_this__u8e3s4);
  }
  return tmp;
}
function serializer_2(_this__u8e3s4) {
  return StringSerializer_getInstance();
}
function MapSerializer(keySerializer, valueSerializer) {
  return new LinkedHashMapSerializer(keySerializer, valueSerializer);
}
function serializer_3(_this__u8e3s4) {
  return ULongSerializer_getInstance();
}
function ListSerializer(elementSerializer) {
  return new ArrayListSerializer(elementSerializer);
}
function serializer_4(_this__u8e3s4) {
  return UIntSerializer_getInstance();
}
function serializer_5(_this__u8e3s4) {
  return UByteSerializer_getInstance();
}
function serializer_6(_this__u8e3s4) {
  return UShortSerializer_getInstance();
}
function MapEntrySerializer(keySerializer, valueSerializer) {
  return new MapEntrySerializer_0(keySerializer, valueSerializer);
}
function PairSerializer(keySerializer, valueSerializer) {
  return new PairSerializer_0(keySerializer, valueSerializer);
}
function TripleSerializer(aSerializer, bSerializer, cSerializer) {
  return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
}
function ArraySerializer(kClass, elementSerializer) {
  return new ReferenceArraySerializer(kClass, elementSerializer);
}
function serializer_7(_this__u8e3s4) {
  return LongSerializer_getInstance();
}
function serializer_8(_this__u8e3s4) {
  return IntSerializer_getInstance();
}
function serializer_9(_this__u8e3s4) {
  return ByteSerializer_getInstance();
}
function serializer_10(_this__u8e3s4) {
  return ShortSerializer_getInstance();
}
function serializer_11(_this__u8e3s4) {
  return CharSerializer_getInstance();
}
function CharArraySerializer() {
  return CharArraySerializer_getInstance();
}
function serializer_12(_this__u8e3s4) {
  return DoubleSerializer_getInstance();
}
function DoubleArraySerializer() {
  return DoubleArraySerializer_getInstance();
}
function serializer_13(_this__u8e3s4) {
  return FloatSerializer_getInstance();
}
function FloatArraySerializer() {
  return FloatArraySerializer_getInstance();
}
function LongArraySerializer() {
  return LongArraySerializer_getInstance();
}
function ULongArraySerializer() {
  return ULongArraySerializer_getInstance();
}
function IntArraySerializer() {
  return IntArraySerializer_getInstance();
}
function UIntArraySerializer() {
  return UIntArraySerializer_getInstance();
}
function ShortArraySerializer() {
  return ShortArraySerializer_getInstance();
}
function UShortArraySerializer() {
  return UShortArraySerializer_getInstance();
}
function ByteArraySerializer() {
  return ByteArraySerializer_getInstance();
}
function UByteArraySerializer() {
  return UByteArraySerializer_getInstance();
}
function serializer_14(_this__u8e3s4) {
  return BooleanSerializer_getInstance();
}
function BooleanArraySerializer() {
  return BooleanArraySerializer_getInstance();
}
function serializer_15(_this__u8e3s4) {
  return UnitSerializer_getInstance();
}
function NothingSerializer() {
  return NothingSerializer_getInstance();
}
function serializer_16(_this__u8e3s4) {
  return DurationSerializer_getInstance();
}
function serializer_17(_this__u8e3s4) {
  return InstantSerializer_getInstance();
}
function serializer_18(_this__u8e3s4) {
  return UuidSerializer_getInstance();
}
function SetSerializer(elementSerializer) {
  return new LinkedHashSetSerializer(elementSerializer);
}
function getContextualDescriptor(_this__u8e3s4, descriptor) {
  var tmp0_safe_receiver = get_capturedKClass(descriptor);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = _this__u8e3s4.oq(tmp0_safe_receiver);
    tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.fp();
  }
  return tmp;
}
function get_capturedKClass(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ContextDescriptor) {
    tmp = _this__u8e3s4.xq_1;
  } else {
    if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
      tmp = get_capturedKClass(_this__u8e3s4.tq_1);
    } else {
      tmp = null;
    }
  }
  return tmp;
}
function ContextDescriptor(original, kClass) {
  this.wq_1 = original;
  this.xq_1 = kClass;
  this.yq_1 = this.wq_1.gq() + '<' + this.xq_1.ea() + '>';
}
protoOf(ContextDescriptor).gq = function () {
  return this.yq_1;
};
protoOf(ContextDescriptor).equals = function (other) {
  var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var another = tmp;
  return equals(this.wq_1, another.wq_1) && another.xq_1.equals(this.xq_1);
};
protoOf(ContextDescriptor).hashCode = function () {
  var result = this.xq_1.hashCode();
  result = imul(31, result) + getStringHashCode(this.yq_1) | 0;
  return result;
};
protoOf(ContextDescriptor).toString = function () {
  return 'ContextDescriptor(kClass: ' + toString(this.xq_1) + ', original: ' + toString(this.wq_1) + ')';
};
protoOf(ContextDescriptor).zq = function () {
  return this.wq_1.zq();
};
protoOf(ContextDescriptor).sq = function () {
  return this.wq_1.sq();
};
protoOf(ContextDescriptor).ar = function () {
  return this.wq_1.ar();
};
protoOf(ContextDescriptor).br = function () {
  return this.wq_1.br();
};
protoOf(ContextDescriptor).cr = function () {
  return this.wq_1.cr();
};
protoOf(ContextDescriptor).dr = function (index) {
  return this.wq_1.dr(index);
};
protoOf(ContextDescriptor).er = function (name) {
  return this.wq_1.er(name);
};
protoOf(ContextDescriptor).fr = function (index) {
  return this.wq_1.fr(index);
};
protoOf(ContextDescriptor).gr = function (index) {
  return this.wq_1.gr(index);
};
protoOf(ContextDescriptor).hr = function (index) {
  return this.wq_1.hr(index);
};
function withContext(_this__u8e3s4, context) {
  return new ContextDescriptor(_this__u8e3s4, context);
}
function SerialDescriptor() {
}
function get_elementNames(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new elementNames$$inlined$Iterable$1(_this__u8e3s4);
}
function get_elementDescriptors(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new elementDescriptors$$inlined$Iterable$1(_this__u8e3s4);
}
function elementNames$1($this_elementNames) {
  this.jr_1 = $this_elementNames;
  this.ir_1 = $this_elementNames.br();
}
protoOf(elementNames$1).m = function () {
  return this.ir_1 > 0;
};
protoOf(elementNames$1).n = function () {
  var tmp = this.jr_1.br();
  var _unary__edvuaz = this.ir_1;
  this.ir_1 = _unary__edvuaz - 1 | 0;
  return this.jr_1.dr(tmp - _unary__edvuaz | 0);
};
function elementNames$$inlined$Iterable$1($this_elementNames) {
  this.kr_1 = $this_elementNames;
}
protoOf(elementNames$$inlined$Iterable$1).l = function () {
  return new elementNames$1(this.kr_1);
};
function elementDescriptors$1($this_elementDescriptors) {
  this.mr_1 = $this_elementDescriptors;
  this.lr_1 = $this_elementDescriptors.br();
}
protoOf(elementDescriptors$1).m = function () {
  return this.lr_1 > 0;
};
protoOf(elementDescriptors$1).n = function () {
  var tmp = this.mr_1.br();
  var _unary__edvuaz = this.lr_1;
  this.lr_1 = _unary__edvuaz - 1 | 0;
  return this.mr_1.gr(tmp - _unary__edvuaz | 0);
};
function elementDescriptors$$inlined$Iterable$1($this_elementDescriptors) {
  this.nr_1 = $this_elementDescriptors;
}
protoOf(elementDescriptors$$inlined$Iterable$1).l = function () {
  return new elementDescriptors$1(this.nr_1);
};
function PrimitiveSerialDescriptor(serialName, kind) {
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return PrimitiveDescriptorSafe(serialName, kind);
}
function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
  var tmp;
  if (builder === VOID) {
    tmp = buildSerialDescriptor$lambda;
  } else {
    tmp = builder;
  }
  builder = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!equals(kind, CLASS_getInstance())) {
    var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
  builder(sdBuilder);
  return new SerialDescriptorImpl(serialName, kind, sdBuilder.op_1.o(), toList(typeParameters), sdBuilder);
}
function ClassSerialDescriptorBuilder(serialName) {
  this.lp_1 = serialName;
  this.mp_1 = false;
  this.np_1 = emptyList();
  this.op_1 = ArrayList_init_$Create$_0();
  this.pp_1 = HashSet_init_$Create$();
  this.qp_1 = ArrayList_init_$Create$_0();
  this.rp_1 = ArrayList_init_$Create$_0();
  this.sp_1 = ArrayList_init_$Create$_0();
}
protoOf(ClassSerialDescriptorBuilder).or = function (elementName, descriptor, annotations, isOptional) {
  // Inline function 'kotlin.require' call
  if (!this.pp_1.j(elementName)) {
    var message = "Element with name '" + elementName + "' is already registered in " + this.lp_1;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.plusAssign' call
  this.op_1.j(elementName);
  // Inline function 'kotlin.collections.plusAssign' call
  this.qp_1.j(descriptor);
  // Inline function 'kotlin.collections.plusAssign' call
  this.rp_1.j(annotations);
  // Inline function 'kotlin.collections.plusAssign' call
  this.sp_1.j(isOptional);
};
protoOf(ClassSerialDescriptorBuilder).tp = function (elementName, descriptor, annotations, isOptional, $super) {
  annotations = annotations === VOID ? emptyList() : annotations;
  isOptional = isOptional === VOID ? false : isOptional;
  var tmp;
  if ($super === VOID) {
    this.or(elementName, descriptor, annotations, isOptional);
    tmp = Unit_instance;
  } else {
    tmp = $super.or.call(this, elementName, descriptor, annotations, isOptional);
  }
  return tmp;
};
function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
  var tmp;
  if (builderAction === VOID) {
    tmp = buildClassSerialDescriptor$lambda;
  } else {
    tmp = builderAction;
  }
  builderAction = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
  builderAction(sdBuilder);
  return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.op_1.o(), toList(typeParameters), sdBuilder);
}
function _get__hashCode__tgwhef($this) {
  var tmp0 = $this.as_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_hashCode', 1, tmp, SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp(), null);
  return tmp0.w();
}
function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
  return function () {
    return hashCodeImpl(this$0, this$0.zr_1);
  };
}
function SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp() {
  return function (p0) {
    return _get__hashCode__tgwhef(p0);
  };
}
function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
  this.pr_1 = serialName;
  this.qr_1 = kind;
  this.rr_1 = elementsCount;
  this.sr_1 = builder.np_1;
  this.tr_1 = toHashSet(builder.op_1);
  var tmp = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = builder.op_1;
  tmp.ur_1 = copyToArray(this_0);
  this.vr_1 = compactArray(builder.qp_1);
  var tmp_0 = this;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_1 = builder.rp_1;
  tmp_0.wr_1 = copyToArray(this_1);
  this.xr_1 = toBooleanArray(builder.sp_1);
  var tmp_1 = this;
  // Inline function 'kotlin.collections.map' call
  var this_2 = withIndex(this.ur_1);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.l();
  while (_iterator__ex2g4s.m()) {
    var item = _iterator__ex2g4s.n();
    var tmp$ret$2 = to(item.mf_1, item.lf_1);
    destination.j(tmp$ret$2);
  }
  tmp_1.yr_1 = toMap(destination);
  this.zr_1 = compactArray(typeParameters);
  var tmp_2 = this;
  tmp_2.as_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
}
protoOf(SerialDescriptorImpl).gq = function () {
  return this.pr_1;
};
protoOf(SerialDescriptorImpl).zq = function () {
  return this.qr_1;
};
protoOf(SerialDescriptorImpl).br = function () {
  return this.rr_1;
};
protoOf(SerialDescriptorImpl).cr = function () {
  return this.sr_1;
};
protoOf(SerialDescriptorImpl).bs = function () {
  return this.tr_1;
};
protoOf(SerialDescriptorImpl).dr = function (index) {
  return getChecked(this.ur_1, index);
};
protoOf(SerialDescriptorImpl).er = function (name) {
  var tmp0_elvis_lhs = this.yr_1.h2(name);
  return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
};
protoOf(SerialDescriptorImpl).fr = function (index) {
  return getChecked(this.wr_1, index);
};
protoOf(SerialDescriptorImpl).gr = function (index) {
  return getChecked(this.vr_1, index);
};
protoOf(SerialDescriptorImpl).hr = function (index) {
  return getChecked_0(this.xr_1, index);
};
protoOf(SerialDescriptorImpl).equals = function (other) {
  var tmp$ret$0;
  $l$block_5: {
    // Inline function 'kotlinx.serialization.internal.equalsImpl' call
    if (this === other) {
      tmp$ret$0 = true;
      break $l$block_5;
    }
    if (!(other instanceof SerialDescriptorImpl)) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.gq() === other.gq())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!contentEquals(this.zr_1, other.zr_1)) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.br() === other.br())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    var inductionVariable = 0;
    var last = this.br();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.gr(index).gq() === other.gr(index).gq())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
        if (!equals(this.gr(index).zq(), other.gr(index).zq())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
      }
       while (inductionVariable < last);
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
};
protoOf(SerialDescriptorImpl).hashCode = function () {
  return _get__hashCode__tgwhef(this);
};
protoOf(SerialDescriptorImpl).toString = function () {
  return toStringImpl(this);
};
function buildSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function buildClassSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function BOOLEAN() {
  BOOLEAN_instance = this;
  PrimitiveKind.call(this);
}
var BOOLEAN_instance;
function BOOLEAN_getInstance() {
  if (BOOLEAN_instance == null)
    new BOOLEAN();
  return BOOLEAN_instance;
}
function BYTE() {
  BYTE_instance = this;
  PrimitiveKind.call(this);
}
var BYTE_instance;
function BYTE_getInstance() {
  if (BYTE_instance == null)
    new BYTE();
  return BYTE_instance;
}
function CHAR() {
  CHAR_instance = this;
  PrimitiveKind.call(this);
}
var CHAR_instance;
function CHAR_getInstance() {
  if (CHAR_instance == null)
    new CHAR();
  return CHAR_instance;
}
function SHORT() {
  SHORT_instance = this;
  PrimitiveKind.call(this);
}
var SHORT_instance;
function SHORT_getInstance() {
  if (SHORT_instance == null)
    new SHORT();
  return SHORT_instance;
}
function INT() {
  INT_instance = this;
  PrimitiveKind.call(this);
}
var INT_instance;
function INT_getInstance() {
  if (INT_instance == null)
    new INT();
  return INT_instance;
}
function LONG() {
  LONG_instance = this;
  PrimitiveKind.call(this);
}
var LONG_instance;
function LONG_getInstance() {
  if (LONG_instance == null)
    new LONG();
  return LONG_instance;
}
function FLOAT() {
  FLOAT_instance = this;
  PrimitiveKind.call(this);
}
var FLOAT_instance;
function FLOAT_getInstance() {
  if (FLOAT_instance == null)
    new FLOAT();
  return FLOAT_instance;
}
function DOUBLE() {
  DOUBLE_instance = this;
  PrimitiveKind.call(this);
}
var DOUBLE_instance;
function DOUBLE_getInstance() {
  if (DOUBLE_instance == null)
    new DOUBLE();
  return DOUBLE_instance;
}
function STRING() {
  STRING_instance = this;
  PrimitiveKind.call(this);
}
var STRING_instance;
function STRING_getInstance() {
  if (STRING_instance == null)
    new STRING();
  return STRING_instance;
}
function PrimitiveKind() {
  SerialKind.call(this);
}
function SEALED() {
  SEALED_instance = this;
  PolymorphicKind.call(this);
}
var SEALED_instance;
function SEALED_getInstance() {
  if (SEALED_instance == null)
    new SEALED();
  return SEALED_instance;
}
function OPEN() {
  OPEN_instance = this;
  PolymorphicKind.call(this);
}
var OPEN_instance;
function OPEN_getInstance() {
  if (OPEN_instance == null)
    new OPEN();
  return OPEN_instance;
}
function PolymorphicKind() {
  SerialKind.call(this);
}
function ENUM() {
  ENUM_instance = this;
  SerialKind.call(this);
}
var ENUM_instance;
function ENUM_getInstance() {
  if (ENUM_instance == null)
    new ENUM();
  return ENUM_instance;
}
function CONTEXTUAL() {
  CONTEXTUAL_instance = this;
  SerialKind.call(this);
}
var CONTEXTUAL_instance;
function CONTEXTUAL_getInstance() {
  if (CONTEXTUAL_instance == null)
    new CONTEXTUAL();
  return CONTEXTUAL_instance;
}
function SerialKind() {
}
protoOf(SerialKind).toString = function () {
  return ensureNotNull(getKClassFromExpression(this).ea());
};
protoOf(SerialKind).hashCode = function () {
  return getStringHashCode(this.toString());
};
function CLASS() {
  CLASS_instance = this;
  StructureKind.call(this);
}
var CLASS_instance;
function CLASS_getInstance() {
  if (CLASS_instance == null)
    new CLASS();
  return CLASS_instance;
}
function LIST() {
  LIST_instance = this;
  StructureKind.call(this);
}
var LIST_instance;
function LIST_getInstance() {
  if (LIST_instance == null)
    new LIST();
  return LIST_instance;
}
function MAP() {
  MAP_instance = this;
  StructureKind.call(this);
}
var MAP_instance;
function MAP_getInstance() {
  if (MAP_instance == null)
    new MAP();
  return MAP_instance;
}
function OBJECT() {
  OBJECT_instance = this;
  StructureKind.call(this);
}
var OBJECT_instance;
function OBJECT_getInstance() {
  if (OBJECT_instance == null)
    new OBJECT();
  return OBJECT_instance;
}
function StructureKind() {
  SerialKind.call(this);
}
function AbstractDecoder() {
}
protoOf(AbstractDecoder).cs = function () {
  throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
};
protoOf(AbstractDecoder).ds = function () {
  return true;
};
protoOf(AbstractDecoder).es = function () {
  return null;
};
protoOf(AbstractDecoder).fs = function () {
  var tmp = this.cs();
  return typeof tmp === 'boolean' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).gs = function () {
  var tmp = this.cs();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).hs = function () {
  var tmp = this.cs();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).is = function () {
  var tmp = this.cs();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).js = function () {
  var tmp = this.cs();
  return typeof tmp === 'bigint' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).ks = function () {
  var tmp = this.cs();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).ls = function () {
  var tmp = this.cs();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).ms = function () {
  var tmp = this.cs();
  return tmp instanceof Char ? tmp.e1_1 : THROW_CCE();
};
protoOf(AbstractDecoder).ns = function () {
  var tmp = this.cs();
  return typeof tmp === 'string' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).os = function (enumDescriptor) {
  var tmp = this.cs();
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(AbstractDecoder).ps = function (descriptor) {
  return this;
};
protoOf(AbstractDecoder).qs = function (deserializer, previousValue) {
  return this.rs(deserializer);
};
protoOf(AbstractDecoder).ss = function (descriptor) {
  return this;
};
protoOf(AbstractDecoder).ts = function (descriptor) {
};
protoOf(AbstractDecoder).us = function (descriptor, index) {
  return this.fs();
};
protoOf(AbstractDecoder).vs = function (descriptor, index) {
  return this.gs();
};
protoOf(AbstractDecoder).ws = function (descriptor, index) {
  return this.hs();
};
protoOf(AbstractDecoder).xs = function (descriptor, index) {
  return this.is();
};
protoOf(AbstractDecoder).ys = function (descriptor, index) {
  return this.js();
};
protoOf(AbstractDecoder).zs = function (descriptor, index) {
  return this.ks();
};
protoOf(AbstractDecoder).at = function (descriptor, index) {
  return this.ls();
};
protoOf(AbstractDecoder).bt = function (descriptor, index) {
  return this.ms();
};
protoOf(AbstractDecoder).ct = function (descriptor, index) {
  return this.ns();
};
protoOf(AbstractDecoder).dt = function (descriptor, index) {
  return this.ps(descriptor.gr(index));
};
protoOf(AbstractDecoder).et = function (descriptor, index, deserializer, previousValue) {
  return this.qs(deserializer, previousValue);
};
protoOf(AbstractDecoder).gt = function (descriptor, index, deserializer, previousValue) {
  // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
  var isNullabilitySupported = deserializer.fp().sq();
  var tmp;
  if (isNullabilitySupported || this.ds()) {
    tmp = this.qs(deserializer, previousValue);
  } else {
    tmp = this.es();
  }
  return tmp;
};
function AbstractEncoder() {
}
protoOf(AbstractEncoder).ss = function (descriptor) {
  return this;
};
protoOf(AbstractEncoder).ts = function (descriptor) {
};
protoOf(AbstractEncoder).lt = function (descriptor, index) {
  return true;
};
protoOf(AbstractEncoder).mt = function (value) {
  throw SerializationException_init_$Create$_0('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
};
protoOf(AbstractEncoder).nt = function () {
  throw SerializationException_init_$Create$_0("'null' is not supported by default");
};
protoOf(AbstractEncoder).ot = function (value) {
  return this.mt(value);
};
protoOf(AbstractEncoder).pt = function (value) {
  return this.mt(value);
};
protoOf(AbstractEncoder).qt = function (value) {
  return this.mt(value);
};
protoOf(AbstractEncoder).rt = function (value) {
  return this.mt(value);
};
protoOf(AbstractEncoder).st = function (value) {
  return this.mt(value);
};
protoOf(AbstractEncoder).tt = function (value) {
  return this.mt(value);
};
protoOf(AbstractEncoder).ut = function (value) {
  return this.mt(value);
};
protoOf(AbstractEncoder).vt = function (value) {
  return this.mt(new Char(value));
};
protoOf(AbstractEncoder).wt = function (value) {
  return this.mt(value);
};
protoOf(AbstractEncoder).xt = function (enumDescriptor, index) {
  return this.mt(index);
};
protoOf(AbstractEncoder).yt = function (descriptor) {
  return this;
};
protoOf(AbstractEncoder).zt = function (descriptor, index, value) {
  if (this.lt(descriptor, index)) {
    this.ot(value);
  }
};
protoOf(AbstractEncoder).au = function (descriptor, index, value) {
  if (this.lt(descriptor, index)) {
    this.pt(value);
  }
};
protoOf(AbstractEncoder).bu = function (descriptor, index, value) {
  if (this.lt(descriptor, index)) {
    this.qt(value);
  }
};
protoOf(AbstractEncoder).cu = function (descriptor, index, value) {
  if (this.lt(descriptor, index)) {
    this.rt(value);
  }
};
protoOf(AbstractEncoder).du = function (descriptor, index, value) {
  if (this.lt(descriptor, index)) {
    this.st(value);
  }
};
protoOf(AbstractEncoder).eu = function (descriptor, index, value) {
  if (this.lt(descriptor, index)) {
    this.tt(value);
  }
};
protoOf(AbstractEncoder).fu = function (descriptor, index, value) {
  if (this.lt(descriptor, index)) {
    this.ut(value);
  }
};
protoOf(AbstractEncoder).gu = function (descriptor, index, value) {
  if (this.lt(descriptor, index)) {
    this.vt(value);
  }
};
protoOf(AbstractEncoder).hu = function (descriptor, index, value) {
  if (this.lt(descriptor, index)) {
    this.wt(value);
  }
};
protoOf(AbstractEncoder).iu = function (descriptor, index) {
  return this.lt(descriptor, index) ? this.yt(descriptor.gr(index)) : NoOpEncoder_getInstance();
};
protoOf(AbstractEncoder).ju = function (descriptor, index, serializer, value) {
  if (this.lt(descriptor, index)) {
    this.ku(serializer, value);
  }
};
protoOf(AbstractEncoder).lu = function (descriptor, index, serializer, value) {
  if (this.lt(descriptor, index)) {
    this.mu(serializer, value);
  }
};
function Decoder() {
}
function CompositeDecoder() {
}
function Encoder() {
}
function CompositeEncoder() {
}
function decodeSequentially_0($this, compositeDecoder) {
  var klassName = compositeDecoder.ct($this.fp(), 0);
  var serializer = findPolymorphicSerializer($this, compositeDecoder, klassName);
  return compositeDecoder.ft($this.fp(), 1, serializer);
}
function AbstractPolymorphicSerializer() {
}
protoOf(AbstractPolymorphicSerializer).xp = function (encoder, value) {
  var actualSerializer = findPolymorphicSerializer_0(this, encoder, value);
  // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
  var descriptor = this.fp();
  var composite = encoder.ss(descriptor);
  composite.hu(this.fp(), 0, actualSerializer.fp().gq());
  var tmp = this.fp();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
  composite.ju(tmp, 1, tmp$ret$0, value);
  composite.ts(descriptor);
};
protoOf(AbstractPolymorphicSerializer).gp = function (encoder, value) {
  return this.xp(encoder, !(value == null) ? value : THROW_CCE());
};
protoOf(AbstractPolymorphicSerializer).hp = function (decoder) {
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.fp();
  var composite = decoder.ss(descriptor);
  var tmp$ret$0;
  $l$block: {
    var klassName = null;
    var value = null;
    if (composite.it()) {
      tmp$ret$0 = decodeSequentially_0(this, composite);
      break $l$block;
    }
    mainLoop: while (true) {
      var index = composite.jt(this.fp());
      switch (index) {
        case -1:
          break mainLoop;
        case 0:
          klassName = composite.ct(this.fp(), index);
          break;
        case 1:
          var tmp0 = klassName;
          var tmp$ret$2;
          $l$block_0: {
            // Inline function 'kotlin.requireNotNull' call
            if (tmp0 == null) {
              var message = 'Cannot read polymorphic value before its type token';
              throw IllegalArgumentException_init_$Create$(toString(message));
            } else {
              tmp$ret$2 = tmp0;
              break $l$block_0;
            }
          }

          klassName = tmp$ret$2;
          var serializer = findPolymorphicSerializer(this, composite, klassName);
          value = composite.ft(this.fp(), index, serializer);
          break;
        default:
          var tmp0_elvis_lhs = klassName;
          throw SerializationException_init_$Create$_0('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
      }
    }
    var tmp0_0 = value;
    var tmp$ret$4;
    $l$block_1: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0_0 == null) {
        var message_0 = 'Polymorphic value has not been read for class ' + klassName;
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      } else {
        tmp$ret$4 = tmp0_0;
        break $l$block_1;
      }
    }
    var tmp = tmp$ret$4;
    tmp$ret$0 = !(tmp == null) ? tmp : THROW_CCE();
  }
  var result = tmp$ret$0;
  composite.ts(descriptor);
  return result;
};
protoOf(AbstractPolymorphicSerializer).ip = function (decoder, klassName) {
  return decoder.ht().qu(this.jp(), klassName);
};
protoOf(AbstractPolymorphicSerializer).kp = function (encoder, value) {
  return encoder.ht().ru(this.jp(), value);
};
function throwSubtypeNotRegistered(subClassName, baseClass) {
  var scope = "in the polymorphic scope of '" + baseClass.ea() + "'";
  throw SerializationException_init_$Create$_0(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.ea() + "' has to be sealed and '@Serializable'."));
}
function throwSubtypeNotRegistered_0(subClass, baseClass) {
  var tmp0_elvis_lhs = subClass.ea();
  throwSubtypeNotRegistered(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
}
function NothingSerializer_0() {
  NothingSerializer_instance = this;
  this.su_1 = NothingSerialDescriptor_getInstance();
}
protoOf(NothingSerializer_0).fp = function () {
  return this.su_1;
};
protoOf(NothingSerializer_0).tu = function (encoder, value) {
  throw SerializationException_init_$Create$_0("'kotlin.Nothing' cannot be serialized");
};
protoOf(NothingSerializer_0).gp = function (encoder, value) {
  var tmp;
  if (false) {
    tmp = value;
  } else {
    tmp = THROW_CCE();
  }
  return this.tu(encoder, tmp);
};
protoOf(NothingSerializer_0).hp = function (decoder) {
  throw SerializationException_init_$Create$_0("'kotlin.Nothing' does not have instances");
};
var NothingSerializer_instance;
function NothingSerializer_getInstance() {
  if (NothingSerializer_instance == null)
    new NothingSerializer_0();
  return NothingSerializer_instance;
}
function DurationSerializer() {
  DurationSerializer_instance = this;
  this.uu_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Duration', STRING_getInstance());
}
protoOf(DurationSerializer).fp = function () {
  return this.uu_1;
};
protoOf(DurationSerializer).vu = function (encoder, value) {
  encoder.wt(Duration__toIsoString_impl_9h6wsm(value));
};
protoOf(DurationSerializer).gp = function (encoder, value) {
  return this.vu(encoder, value instanceof Duration ? value.ul_1 : THROW_CCE());
};
protoOf(DurationSerializer).wu = function (decoder) {
  return Companion_getInstance().tl(decoder.ns());
};
protoOf(DurationSerializer).hp = function (decoder) {
  return new Duration(this.wu(decoder));
};
var DurationSerializer_instance;
function DurationSerializer_getInstance() {
  if (DurationSerializer_instance == null)
    new DurationSerializer();
  return DurationSerializer_instance;
}
function InstantSerializer() {
  InstantSerializer_instance = this;
  this.xu_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Instant', STRING_getInstance());
}
protoOf(InstantSerializer).fp = function () {
  return this.xu_1;
};
protoOf(InstantSerializer).yu = function (encoder, value) {
  encoder.wt(value.toString());
};
protoOf(InstantSerializer).gp = function (encoder, value) {
  return this.yu(encoder, value instanceof Instant ? value : THROW_CCE());
};
protoOf(InstantSerializer).hp = function (decoder) {
  return Companion_getInstance_0().yl(decoder.ns());
};
var InstantSerializer_instance;
function InstantSerializer_getInstance() {
  if (InstantSerializer_instance == null)
    new InstantSerializer();
  return InstantSerializer_instance;
}
function UuidSerializer() {
  UuidSerializer_instance = this;
  this.zu_1 = new PrimitiveSerialDescriptor_0('kotlin.uuid.Uuid', STRING_getInstance());
}
protoOf(UuidSerializer).fp = function () {
  return this.zu_1;
};
protoOf(UuidSerializer).av = function (encoder, value) {
  encoder.wt(value.toString());
};
protoOf(UuidSerializer).gp = function (encoder, value) {
  return this.av(encoder, value instanceof Uuid ? value : THROW_CCE());
};
protoOf(UuidSerializer).hp = function (decoder) {
  return Companion_getInstance_1().in(decoder.ns());
};
var UuidSerializer_instance;
function UuidSerializer_getInstance() {
  if (UuidSerializer_instance == null)
    new UuidSerializer();
  return UuidSerializer_instance;
}
function CachedNames() {
}
function ArrayListClassDesc(elementDesc) {
  ListLikeDescriptor.call(this, elementDesc);
}
protoOf(ArrayListClassDesc).gq = function () {
  return 'kotlin.collections.ArrayList';
};
function HashSetClassDesc(elementDesc) {
  ListLikeDescriptor.call(this, elementDesc);
}
protoOf(HashSetClassDesc).gq = function () {
  return 'kotlin.collections.HashSet';
};
function LinkedHashSetClassDesc(elementDesc) {
  ListLikeDescriptor.call(this, elementDesc);
}
protoOf(LinkedHashSetClassDesc).gq = function () {
  return 'kotlin.collections.LinkedHashSet';
};
function HashMapClassDesc(keyDesc, valueDesc) {
  MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
}
function LinkedHashMapClassDesc(keyDesc, valueDesc) {
  MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
}
function ArrayClassDesc(elementDesc) {
  ListLikeDescriptor.call(this, elementDesc);
}
protoOf(ArrayClassDesc).gq = function () {
  return 'kotlin.Array';
};
function ListLikeDescriptor(elementDescriptor) {
  this.dv_1 = elementDescriptor;
  this.ev_1 = 1;
}
protoOf(ListLikeDescriptor).zq = function () {
  return LIST_getInstance();
};
protoOf(ListLikeDescriptor).br = function () {
  return this.ev_1;
};
protoOf(ListLikeDescriptor).dr = function (index) {
  return index.toString();
};
protoOf(ListLikeDescriptor).er = function (name) {
  var tmp0_elvis_lhs = toIntOrNull(name);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$(name + ' is not a valid list index');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(ListLikeDescriptor).hr = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.gq() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return false;
};
protoOf(ListLikeDescriptor).fr = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.gq() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return emptyList();
};
protoOf(ListLikeDescriptor).gr = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.gq() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return this.dv_1;
};
protoOf(ListLikeDescriptor).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ListLikeDescriptor))
    return false;
  if (equals(this.dv_1, other.dv_1) && this.gq() === other.gq())
    return true;
  return false;
};
protoOf(ListLikeDescriptor).hashCode = function () {
  return imul(hashCode(this.dv_1), 31) + getStringHashCode(this.gq()) | 0;
};
protoOf(ListLikeDescriptor).toString = function () {
  return this.gq() + '(' + toString(this.dv_1) + ')';
};
function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
  this.jv_1 = serialName;
  this.kv_1 = keyDescriptor;
  this.lv_1 = valueDescriptor;
  this.mv_1 = 2;
}
protoOf(MapLikeDescriptor).gq = function () {
  return this.jv_1;
};
protoOf(MapLikeDescriptor).zq = function () {
  return MAP_getInstance();
};
protoOf(MapLikeDescriptor).br = function () {
  return this.mv_1;
};
protoOf(MapLikeDescriptor).dr = function (index) {
  return index.toString();
};
protoOf(MapLikeDescriptor).er = function (name) {
  var tmp0_elvis_lhs = toIntOrNull(name);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$(name + ' is not a valid map index');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(MapLikeDescriptor).hr = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.gq() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return false;
};
protoOf(MapLikeDescriptor).fr = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.gq() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return emptyList();
};
protoOf(MapLikeDescriptor).gr = function (index) {
  // Inline function 'kotlin.require' call
  if (!(index >= 0)) {
    var message = 'Illegal index ' + index + ', ' + this.gq() + ' expects only non-negative indices';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp;
  switch (index % 2 | 0) {
    case 0:
      tmp = this.kv_1;
      break;
    case 1:
      tmp = this.lv_1;
      break;
    default:
      var message_0 = 'Unreached';
      throw IllegalStateException_init_$Create$(toString(message_0));
  }
  return tmp;
};
protoOf(MapLikeDescriptor).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MapLikeDescriptor))
    return false;
  if (!(this.gq() === other.gq()))
    return false;
  if (!equals(this.kv_1, other.kv_1))
    return false;
  if (!equals(this.lv_1, other.lv_1))
    return false;
  return true;
};
protoOf(MapLikeDescriptor).hashCode = function () {
  var result = getStringHashCode(this.gq());
  result = imul(31, result) + hashCode(this.kv_1) | 0;
  result = imul(31, result) + hashCode(this.lv_1) | 0;
  return result;
};
protoOf(MapLikeDescriptor).toString = function () {
  return this.gq() + '(' + toString(this.kv_1) + ', ' + toString(this.lv_1) + ')';
};
function PrimitiveArrayDescriptor(primitive) {
  ListLikeDescriptor.call(this, primitive);
  this.rv_1 = primitive.gq() + 'Array';
}
protoOf(PrimitiveArrayDescriptor).gq = function () {
  return this.rv_1;
};
function ArrayListSerializer(element) {
  CollectionSerializer.call(this, element);
  this.tv_1 = new ArrayListClassDesc(element.fp());
}
protoOf(ArrayListSerializer).fp = function () {
  return this.tv_1;
};
protoOf(ArrayListSerializer).uv = function () {
  // Inline function 'kotlin.collections.arrayListOf' call
  return ArrayList_init_$Create$_0();
};
protoOf(ArrayListSerializer).vv = function (_this__u8e3s4) {
  return _this__u8e3s4.o();
};
protoOf(ArrayListSerializer).wv = function (_this__u8e3s4) {
  return this.vv(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ArrayListSerializer).xv = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(ArrayListSerializer).yv = function (_this__u8e3s4) {
  return this.xv(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ArrayListSerializer).zv = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(ArrayListSerializer).aw = function (_this__u8e3s4) {
  return this.zv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ArrayListSerializer).bw = function (_this__u8e3s4, size) {
  return _this__u8e3s4.s4(size);
};
protoOf(ArrayListSerializer).cw = function (_this__u8e3s4, size) {
  return this.bw(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(ArrayListSerializer).dw = function (_this__u8e3s4, index, element) {
  _this__u8e3s4.y1(index, element);
};
protoOf(ArrayListSerializer).ew = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
  return this.dw(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function HashSetSerializer(eSerializer) {
  CollectionSerializer.call(this, eSerializer);
  this.pw_1 = new HashSetClassDesc(eSerializer.fp());
}
protoOf(HashSetSerializer).fp = function () {
  return this.pw_1;
};
protoOf(HashSetSerializer).uv = function () {
  return HashSet_init_$Create$();
};
protoOf(HashSetSerializer).qw = function (_this__u8e3s4) {
  return _this__u8e3s4.o();
};
protoOf(HashSetSerializer).wv = function (_this__u8e3s4) {
  return this.qw(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashSetSerializer).rw = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(HashSetSerializer).yv = function (_this__u8e3s4) {
  return this.rw(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashSetSerializer).sw = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(HashSetSerializer).aw = function (_this__u8e3s4) {
  return this.sw((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashSetSerializer).tw = function (_this__u8e3s4, size) {
};
protoOf(HashSetSerializer).cw = function (_this__u8e3s4, size) {
  return this.tw(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(HashSetSerializer).uw = function (_this__u8e3s4, index, element) {
  _this__u8e3s4.j(element);
};
protoOf(HashSetSerializer).ew = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE();
  return this.uw(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function LinkedHashSetSerializer(eSerializer) {
  CollectionSerializer.call(this, eSerializer);
  this.ww_1 = new LinkedHashSetClassDesc(eSerializer.fp());
}
protoOf(LinkedHashSetSerializer).fp = function () {
  return this.ww_1;
};
protoOf(LinkedHashSetSerializer).uv = function () {
  // Inline function 'kotlin.collections.linkedSetOf' call
  return LinkedHashSet_init_$Create$();
};
protoOf(LinkedHashSetSerializer).xw = function (_this__u8e3s4) {
  return _this__u8e3s4.o();
};
protoOf(LinkedHashSetSerializer).wv = function (_this__u8e3s4) {
  return this.xw(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashSetSerializer).yw = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(LinkedHashSetSerializer).yv = function (_this__u8e3s4) {
  return this.yw(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashSetSerializer).sw = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(LinkedHashSetSerializer).aw = function (_this__u8e3s4) {
  return this.sw((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashSetSerializer).zw = function (_this__u8e3s4, size) {
};
protoOf(LinkedHashSetSerializer).cw = function (_this__u8e3s4, size) {
  return this.zw(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(LinkedHashSetSerializer).ax = function (_this__u8e3s4, index, element) {
  _this__u8e3s4.j(element);
};
protoOf(LinkedHashSetSerializer).ew = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
  return this.ax(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function HashMapSerializer(kSerializer, vSerializer) {
  MapLikeSerializer.call(this, kSerializer, vSerializer);
  this.dx_1 = new HashMapClassDesc(kSerializer.fp(), vSerializer.fp());
}
protoOf(HashMapSerializer).fp = function () {
  return this.dx_1;
};
protoOf(HashMapSerializer).ex = function (_this__u8e3s4) {
  return _this__u8e3s4.o();
};
protoOf(HashMapSerializer).fx = function (_this__u8e3s4) {
  return this.ex((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).gx = function (_this__u8e3s4) {
  // Inline function 'kotlin.collections.iterator' call
  return _this__u8e3s4.u().l();
};
protoOf(HashMapSerializer).hx = function (_this__u8e3s4) {
  return this.gx((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).uv = function () {
  return HashMap_init_$Create$();
};
protoOf(HashMapSerializer).ix = function (_this__u8e3s4) {
  return imul(_this__u8e3s4.o(), 2);
};
protoOf(HashMapSerializer).wv = function (_this__u8e3s4) {
  return this.ix(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).jx = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(HashMapSerializer).yv = function (_this__u8e3s4) {
  return this.jx(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).kx = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? HashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(HashMapSerializer).aw = function (_this__u8e3s4) {
  return this.kx((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(HashMapSerializer).lx = function (_this__u8e3s4, size) {
};
protoOf(HashMapSerializer).cw = function (_this__u8e3s4, size) {
  return this.lx(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
};
function LinkedHashMapSerializer(kSerializer, vSerializer) {
  MapLikeSerializer.call(this, kSerializer, vSerializer);
  this.sx_1 = new LinkedHashMapClassDesc(kSerializer.fp(), vSerializer.fp());
}
protoOf(LinkedHashMapSerializer).fp = function () {
  return this.sx_1;
};
protoOf(LinkedHashMapSerializer).ex = function (_this__u8e3s4) {
  return _this__u8e3s4.o();
};
protoOf(LinkedHashMapSerializer).fx = function (_this__u8e3s4) {
  return this.ex((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).gx = function (_this__u8e3s4) {
  // Inline function 'kotlin.collections.iterator' call
  return _this__u8e3s4.u().l();
};
protoOf(LinkedHashMapSerializer).hx = function (_this__u8e3s4) {
  return this.gx((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).uv = function () {
  return LinkedHashMap_init_$Create$();
};
protoOf(LinkedHashMapSerializer).tx = function (_this__u8e3s4) {
  return imul(_this__u8e3s4.o(), 2);
};
protoOf(LinkedHashMapSerializer).wv = function (_this__u8e3s4) {
  return this.tx(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).ux = function (_this__u8e3s4) {
  return _this__u8e3s4;
};
protoOf(LinkedHashMapSerializer).yv = function (_this__u8e3s4) {
  return this.ux(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).kx = function (_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
};
protoOf(LinkedHashMapSerializer).aw = function (_this__u8e3s4) {
  return this.kx((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LinkedHashMapSerializer).vx = function (_this__u8e3s4, size) {
};
protoOf(LinkedHashMapSerializer).cw = function (_this__u8e3s4, size) {
  return this.vx(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
};
function ReferenceArraySerializer(kClass, eSerializer) {
  CollectionLikeSerializer.call(this, eSerializer);
  this.xx_1 = kClass;
  this.yx_1 = new ArrayClassDesc(eSerializer.fp());
}
protoOf(ReferenceArraySerializer).fp = function () {
  return this.yx_1;
};
protoOf(ReferenceArraySerializer).zx = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(ReferenceArraySerializer).fx = function (_this__u8e3s4) {
  return this.zx((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).ay = function (_this__u8e3s4) {
  return arrayIterator(_this__u8e3s4);
};
protoOf(ReferenceArraySerializer).hx = function (_this__u8e3s4) {
  return this.ay((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).uv = function () {
  // Inline function 'kotlin.collections.arrayListOf' call
  return ArrayList_init_$Create$_0();
};
protoOf(ReferenceArraySerializer).by = function (_this__u8e3s4) {
  return _this__u8e3s4.o();
};
protoOf(ReferenceArraySerializer).wv = function (_this__u8e3s4) {
  return this.by(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).cy = function (_this__u8e3s4) {
  return toNativeArrayImpl(_this__u8e3s4, this.xx_1);
};
protoOf(ReferenceArraySerializer).yv = function (_this__u8e3s4) {
  return this.cy(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).dy = function (_this__u8e3s4) {
  return ArrayList_init_$Create$_1(asList(_this__u8e3s4));
};
protoOf(ReferenceArraySerializer).aw = function (_this__u8e3s4) {
  return this.dy((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ReferenceArraySerializer).ey = function (_this__u8e3s4, size) {
  return _this__u8e3s4.s4(size);
};
protoOf(ReferenceArraySerializer).cw = function (_this__u8e3s4, size) {
  return this.ey(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(ReferenceArraySerializer).fy = function (_this__u8e3s4, index, element) {
  _this__u8e3s4.y1(index, element);
};
protoOf(ReferenceArraySerializer).ew = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
  return this.fy(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
function CollectionSerializer(element) {
  CollectionLikeSerializer.call(this, element);
}
protoOf(CollectionSerializer).gw = function (_this__u8e3s4) {
  return _this__u8e3s4.o();
};
protoOf(CollectionSerializer).fx = function (_this__u8e3s4) {
  return this.gw((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(CollectionSerializer).hw = function (_this__u8e3s4) {
  return _this__u8e3s4.l();
};
protoOf(CollectionSerializer).hx = function (_this__u8e3s4) {
  return this.hw((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
};
function MapLikeSerializer(keySerializer, valueSerializer) {
  AbstractCollectionSerializer.call(this);
  this.mx_1 = keySerializer;
  this.nx_1 = valueSerializer;
}
protoOf(MapLikeSerializer).ox = function (decoder, builder, startIndex, size) {
  // Inline function 'kotlin.require' call
  if (!(size >= 0)) {
    var message = 'Size must be known in advance when using READ_ALL';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var progression = step(until(0, imul(size, 2)), 2);
  var inductionVariable = progression.z_1;
  var last = progression.a1_1;
  var step_0 = progression.b1_1;
  if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + step_0 | 0;
      this.px(decoder, startIndex + index | 0, builder, false);
    }
     while (!(index === last));
};
protoOf(MapLikeSerializer).kw = function (decoder, builder, startIndex, size) {
  return this.ox(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
};
protoOf(MapLikeSerializer).px = function (decoder, index, builder, checkIndex) {
  var key = decoder.ft(this.fp(), index, this.mx_1);
  var tmp;
  if (checkIndex) {
    // Inline function 'kotlin.also' call
    var this_0 = decoder.jt(this.fp());
    // Inline function 'kotlin.require' call
    if (!(this_0 === (index + 1 | 0))) {
      var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    tmp = this_0;
  } else {
    tmp = index + 1 | 0;
  }
  var vIndex = tmp;
  var tmp_0;
  var tmp_1;
  if (builder.f2(key)) {
    var tmp_2 = this.nx_1.fp().zq();
    tmp_1 = !(tmp_2 instanceof PrimitiveKind);
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = decoder.et(this.fp(), vIndex, this.nx_1, getValue(builder, key));
  } else {
    tmp_0 = decoder.ft(this.fp(), vIndex, this.nx_1);
  }
  var value = tmp_0;
  // Inline function 'kotlin.collections.set' call
  builder.a2(key, value);
};
protoOf(MapLikeSerializer).lw = function (decoder, index, builder, checkIndex) {
  return this.px(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), checkIndex);
};
protoOf(MapLikeSerializer).jw = function (encoder, value) {
  var size = this.fx(value);
  // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
  var descriptor = this.fp();
  var composite = encoder.ou(descriptor, size);
  var iterator = this.hx(value);
  var index = 0;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = iterator;
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    // Inline function 'kotlin.collections.component1' call
    var k = element.v();
    // Inline function 'kotlin.collections.component2' call
    var v = element.w();
    var tmp = this.fp();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    composite.ju(tmp, _unary__edvuaz, this.mx_1, k);
    var tmp_0 = this.fp();
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    composite.ju(tmp_0, _unary__edvuaz_0, this.nx_1, v);
  }
  composite.ts(descriptor);
};
protoOf(MapLikeSerializer).gp = function (encoder, value) {
  return this.jw(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
function CollectionLikeSerializer(elementSerializer) {
  AbstractCollectionSerializer.call(this);
  this.iw_1 = elementSerializer;
}
protoOf(CollectionLikeSerializer).jw = function (encoder, value) {
  var size = this.fx(value);
  // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
  var descriptor = this.fp();
  var composite = encoder.ou(descriptor, size);
  var iterator = this.hx(value);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      composite.ju(this.fp(), index, this.iw_1, iterator.n());
    }
     while (inductionVariable < size);
  composite.ts(descriptor);
};
protoOf(CollectionLikeSerializer).gp = function (encoder, value) {
  return this.jw(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(CollectionLikeSerializer).kw = function (decoder, builder, startIndex, size) {
  // Inline function 'kotlin.require' call
  if (!(size >= 0)) {
    var message = 'Size must be known in advance when using READ_ALL';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.lw(decoder, startIndex + index | 0, builder, false);
    }
     while (inductionVariable < size);
};
protoOf(CollectionLikeSerializer).lw = function (decoder, index, builder, checkIndex) {
  this.ew(builder, index, decoder.ft(this.fp(), index, this.iw_1));
};
function readSize($this, decoder, builder) {
  var size = decoder.kt($this.fp());
  $this.cw(builder, size);
  return size;
}
function AbstractCollectionSerializer() {
}
protoOf(AbstractCollectionSerializer).nw = function (decoder, previous) {
  var tmp1_elvis_lhs = previous == null ? null : this.aw(previous);
  var builder = tmp1_elvis_lhs == null ? this.uv() : tmp1_elvis_lhs;
  var startIndex = this.wv(builder);
  var compositeDecoder = decoder.ss(this.fp());
  if (compositeDecoder.it()) {
    this.kw(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
  } else {
    $l$loop: while (true) {
      var index = compositeDecoder.jt(this.fp());
      if (index === -1)
        break $l$loop;
      this.mw(compositeDecoder, startIndex + index | 0, builder);
    }
  }
  compositeDecoder.ts(this.fp());
  return this.yv(builder);
};
protoOf(AbstractCollectionSerializer).hp = function (decoder) {
  return this.nw(decoder, null);
};
protoOf(AbstractCollectionSerializer).mw = function (decoder, index, builder, checkIndex, $super) {
  checkIndex = checkIndex === VOID ? true : checkIndex;
  var tmp;
  if ($super === VOID) {
    this.lw(decoder, index, builder, checkIndex);
    tmp = Unit_instance;
  } else {
    tmp = $super.lw.call(this, decoder, index, builder, checkIndex);
  }
  return tmp;
};
function PrimitiveArraySerializer(primitiveSerializer) {
  CollectionLikeSerializer.call(this, primitiveSerializer);
  this.hy_1 = new PrimitiveArrayDescriptor(primitiveSerializer.fp());
}
protoOf(PrimitiveArraySerializer).fp = function () {
  return this.hy_1;
};
protoOf(PrimitiveArraySerializer).iy = function (_this__u8e3s4) {
  return _this__u8e3s4.jy();
};
protoOf(PrimitiveArraySerializer).wv = function (_this__u8e3s4) {
  return this.iy(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).ky = function (_this__u8e3s4) {
  return _this__u8e3s4.ly();
};
protoOf(PrimitiveArraySerializer).yv = function (_this__u8e3s4) {
  return this.ky(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).my = function (_this__u8e3s4, size) {
  return _this__u8e3s4.ny(size);
};
protoOf(PrimitiveArraySerializer).cw = function (_this__u8e3s4, size) {
  return this.my(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
};
protoOf(PrimitiveArraySerializer).oy = function (_this__u8e3s4) {
  var message = 'This method lead to boxing and must not be used, use writeContents instead';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(PrimitiveArraySerializer).hx = function (_this__u8e3s4) {
  return this.oy((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).py = function (_this__u8e3s4, index, element) {
  var message = 'This method lead to boxing and must not be used, use Builder.append instead';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(PrimitiveArraySerializer).ew = function (_this__u8e3s4, index, element) {
  var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE();
  return this.py(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).uv = function () {
  return this.aw(this.qy());
};
protoOf(PrimitiveArraySerializer).ty = function (encoder, value) {
  var size = this.fx(value);
  // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
  var descriptor = this.hy_1;
  var composite = encoder.ou(descriptor, size);
  this.sy(composite, value, size);
  composite.ts(descriptor);
};
protoOf(PrimitiveArraySerializer).gp = function (encoder, value) {
  return this.ty(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).jw = function (encoder, value) {
  return this.ty(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(PrimitiveArraySerializer).hp = function (decoder) {
  return this.nw(decoder, null);
};
function PrimitiveArrayBuilder() {
}
protoOf(PrimitiveArrayBuilder).uy = function (requiredCapacity, $super) {
  requiredCapacity = requiredCapacity === VOID ? this.jy() + 1 | 0 : requiredCapacity;
  var tmp;
  if ($super === VOID) {
    this.ny(requiredCapacity);
    tmp = Unit_instance;
  } else {
    tmp = $super.ny.call(this, requiredCapacity);
  }
  return tmp;
};
function Companion() {
  Companion_instance_1 = this;
  this.vy_1 = longArray(0);
}
var Companion_instance_1;
function Companion_getInstance_7() {
  if (Companion_instance_1 == null)
    new Companion();
  return Companion_instance_1;
}
function prepareHighMarksArray($this, elementsCount) {
  var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
  var elementsInLastSlot = elementsCount & 63;
  var highMarks = longArray(slotsCount);
  if (!(elementsInLastSlot === 0)) {
    highMarks[get_lastIndex(highMarks)] = shiftLeft(-1n, elementsCount);
  }
  return highMarks;
}
function markHigh($this, index) {
  var slot = (index >>> 6 | 0) - 1 | 0;
  var offsetInSlot = index & 63;
  $this.zy_1[slot] = $this.zy_1[slot] | shiftLeft(1n, offsetInSlot);
}
function nextUnmarkedHighIndex($this) {
  var inductionVariable = 0;
  var last = $this.zy_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var slot = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var slotOffset = imul(slot + 1 | 0, 64);
      var slotMarks = $this.zy_1[slot];
      while (!(slotMarks === -1n)) {
        var indexInSlot = countTrailingZeroBits(~slotMarks);
        slotMarks = slotMarks | shiftLeft(1n, indexInSlot);
        var index = slotOffset + indexInSlot | 0;
        if ($this.xy_1($this.wy_1, index)) {
          $this.zy_1[slot] = slotMarks;
          return index;
        }
      }
      $this.zy_1[slot] = slotMarks;
    }
     while (inductionVariable <= last);
  return -1;
}
function ElementMarker(descriptor, readIfAbsent) {
  Companion_getInstance_7();
  this.wy_1 = descriptor;
  this.xy_1 = readIfAbsent;
  var elementsCount = this.wy_1.br();
  if (elementsCount <= 64) {
    var tmp = this;
    var tmp_0;
    if (elementsCount === 64) {
      tmp_0 = 0n;
    } else {
      tmp_0 = shiftLeft(-1n, elementsCount);
    }
    tmp.yy_1 = tmp_0;
    this.zy_1 = Companion_getInstance_7().vy_1;
  } else {
    this.yy_1 = 0n;
    this.zy_1 = prepareHighMarksArray(this, elementsCount);
  }
}
protoOf(ElementMarker).az = function (index) {
  if (index < 64) {
    this.yy_1 = this.yy_1 | shiftLeft(1n, index);
  } else {
    markHigh(this, index);
  }
};
protoOf(ElementMarker).bz = function () {
  var elementsCount = this.wy_1.br();
  while (!(this.yy_1 === -1n)) {
    var index = countTrailingZeroBits(~this.yy_1);
    this.yy_1 = this.yy_1 | shiftLeft(1n, index);
    if (this.xy_1(this.wy_1, index)) {
      return index;
    }
  }
  if (elementsCount > 64) {
    return nextUnmarkedHighIndex(this);
  }
  return -1;
};
function createSimpleEnumSerializer(serialName, values) {
  return new EnumSerializer(serialName, values);
}
function createAnnotatedEnumSerializer(serialName, values, names, entryAnnotations, classAnnotations) {
  var descriptor = new EnumDescriptor(serialName, values.length);
  if (classAnnotations == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = classAnnotations.length;
    while (inductionVariable < last) {
      var element = classAnnotations[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      descriptor.oz(element);
    }
  }
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var inductionVariable_0 = 0;
  var last_0 = values.length;
  while (inductionVariable_0 < last_0) {
    var item = values[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var tmp0_elvis_lhs = getOrNull(names, _unary__edvuaz);
    var elementName = tmp0_elvis_lhs == null ? item.i2_1 : tmp0_elvis_lhs;
    descriptor.pz(elementName);
    var tmp1_safe_receiver = getOrNull(entryAnnotations, _unary__edvuaz);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_1 = 0;
      var last_1 = tmp1_safe_receiver.length;
      while (inductionVariable_1 < last_1) {
        var element_0 = tmp1_safe_receiver[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        descriptor.qz(element_0);
      }
    }
  }
  return EnumSerializer_init_$Create$(serialName, values, descriptor);
}
function EnumSerializer_init_$Init$(serialName, values, descriptor, $this) {
  EnumSerializer.call($this, serialName, values);
  $this.sz_1 = descriptor;
  return $this;
}
function EnumSerializer_init_$Create$(serialName, values, descriptor) {
  return EnumSerializer_init_$Init$(serialName, values, descriptor, objectCreate(protoOf(EnumSerializer)));
}
function createUnmarkedDescriptor($this, serialName) {
  var d = new EnumDescriptor(serialName, $this.rz_1.length);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = $this.rz_1;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    d.pz(element.i2_1);
  }
  return d;
}
function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
  return function () {
    var tmp0_elvis_lhs = this$0.sz_1;
    return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
  };
}
function EnumSerializer$_get_descriptor_$ref_j67dlw() {
  return function (p0) {
    return p0.fp();
  };
}
function EnumSerializer(serialName, values) {
  this.rz_1 = values;
  this.sz_1 = null;
  var tmp = this;
  tmp.tz_1 = lazy_0(EnumSerializer$descriptor$delegate$lambda(this, serialName));
}
protoOf(EnumSerializer).fp = function () {
  var tmp0 = this.tz_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('descriptor', 1, tmp, EnumSerializer$_get_descriptor_$ref_j67dlw(), null);
  return tmp0.w();
};
protoOf(EnumSerializer).uz = function (encoder, value) {
  var index = indexOf(this.rz_1, value);
  if (index === -1) {
    throw SerializationException_init_$Create$_0(toString(value) + ' is not a valid enum ' + this.fp().gq() + ', ' + ('must be one of ' + contentToString(this.rz_1)));
  }
  encoder.xt(this.fp(), index);
};
protoOf(EnumSerializer).gp = function (encoder, value) {
  return this.uz(encoder, value instanceof Enum ? value : THROW_CCE());
};
protoOf(EnumSerializer).hp = function (decoder) {
  var index = decoder.os(this.fp());
  if (!(0 <= index ? index <= (this.rz_1.length - 1 | 0) : false)) {
    throw SerializationException_init_$Create$_0('' + index + ' is not among valid ' + this.fp().gq() + ' enum values, ' + ('values size is ' + this.rz_1.length));
  }
  return this.rz_1[index];
};
protoOf(EnumSerializer).toString = function () {
  return 'kotlinx.serialization.internal.EnumSerializer<' + this.fp().gq() + '>';
};
function _get_elementDescriptors__y23q9p($this) {
  var tmp0 = $this.i10_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('elementDescriptors', 1, tmp, EnumDescriptor$_get_elementDescriptors_$ref_5lvk4a(), null);
  return tmp0.w();
}
function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
  return function () {
    var tmp = 0;
    var tmp_0 = $elementsCount;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = buildSerialDescriptor($name + '.' + this$0.dr(tmp_2), OBJECT_getInstance(), []);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
function EnumDescriptor$_get_elementDescriptors_$ref_5lvk4a() {
  return function (p0) {
    return _get_elementDescriptors__y23q9p(p0);
  };
}
function EnumDescriptor(name, elementsCount) {
  PluginGeneratedSerialDescriptor.call(this, name, VOID, elementsCount);
  this.h10_1 = ENUM_getInstance();
  var tmp = this;
  tmp.i10_1 = lazy_0(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
}
protoOf(EnumDescriptor).zq = function () {
  return this.h10_1;
};
protoOf(EnumDescriptor).gr = function (index) {
  return getChecked(_get_elementDescriptors__y23q9p(this), index);
};
protoOf(EnumDescriptor).equals = function (other) {
  if (this === other)
    return true;
  if (other == null)
    return false;
  if (!(!(other == null) ? isInterface(other, SerialDescriptor) : false))
    return false;
  if (!(other.zq() === ENUM_getInstance()))
    return false;
  if (!(this.gq() === other.gq()))
    return false;
  if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
    return false;
  return true;
};
protoOf(EnumDescriptor).toString = function () {
  return joinToString(get_elementNames(this), ', ', this.gq() + '(', ')');
};
protoOf(EnumDescriptor).hashCode = function () {
  var result = getStringHashCode(this.gq());
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 1;
  var _iterator__ex2g4s = get_elementNames(this).l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    var hash = accumulator;
    var tmp = imul(31, hash);
    // Inline function 'kotlin.hashCode' call
    var tmp1_elvis_lhs = element == null ? null : hashCode(element);
    accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  var elementsHashCode = accumulator;
  result = imul(31, result) + elementsHashCode | 0;
  return result;
};
function InlinePrimitiveDescriptor(name, primitiveSerializer) {
  return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
}
function InlineClassDescriptor(name, generatedSerializer) {
  PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
  this.x10_1 = true;
}
protoOf(InlineClassDescriptor).ar = function () {
  return this.x10_1;
};
protoOf(InlineClassDescriptor).hashCode = function () {
  return imul(protoOf(PluginGeneratedSerialDescriptor).hashCode.call(this), 31);
};
protoOf(InlineClassDescriptor).equals = function (other) {
  var tmp$ret$0;
  $l$block_5: {
    // Inline function 'kotlinx.serialization.internal.equalsImpl' call
    if (this === other) {
      tmp$ret$0 = true;
      break $l$block_5;
    }
    if (!(other instanceof InlineClassDescriptor)) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.gq() === other.gq())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(other.x10_1 && contentEquals(this.j10(), other.j10()))) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.br() === other.br())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    var inductionVariable = 0;
    var last = this.br();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.gr(index).gq() === other.gr(index).gq())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
        if (!equals(this.gr(index).zq(), other.gr(index).zq())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
      }
       while (inductionVariable < last);
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
};
function InlinePrimitiveDescriptor$1($primitiveSerializer) {
  this.y10_1 = $primitiveSerializer;
}
protoOf(InlinePrimitiveDescriptor$1).z10 = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [this.y10_1];
};
protoOf(InlinePrimitiveDescriptor$1).fp = function () {
  var message = 'unsupported';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(InlinePrimitiveDescriptor$1).gp = function (encoder, value) {
  // Inline function 'kotlin.error' call
  var message = 'unsupported';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(InlinePrimitiveDescriptor$1).hp = function (decoder) {
  // Inline function 'kotlin.error' call
  var message = 'unsupported';
  throw IllegalStateException_init_$Create$(toString(message));
};
function jsonCachedSerialNames(_this__u8e3s4) {
  return cachedSerialNames(_this__u8e3s4);
}
function NoOpEncoder() {
  NoOpEncoder_instance = this;
  AbstractEncoder.call(this);
  this.b11_1 = EmptySerializersModule_0();
}
protoOf(NoOpEncoder).ht = function () {
  return this.b11_1;
};
protoOf(NoOpEncoder).mt = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).nt = function () {
  return Unit_instance;
};
protoOf(NoOpEncoder).ot = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).pt = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).qt = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).rt = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).st = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).tt = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).ut = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).vt = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).wt = function (value) {
  return Unit_instance;
};
protoOf(NoOpEncoder).xt = function (enumDescriptor, index) {
  return Unit_instance;
};
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance == null)
    new NoOpEncoder();
  return NoOpEncoder_instance;
}
function error($this) {
  throw IllegalStateException_init_$Create$('Descriptor for type `kotlin.Nothing` does not have elements');
}
function NothingSerialDescriptor() {
  NothingSerialDescriptor_instance = this;
  this.c11_1 = OBJECT_getInstance();
  this.d11_1 = 'kotlin.Nothing';
}
protoOf(NothingSerialDescriptor).zq = function () {
  return this.c11_1;
};
protoOf(NothingSerialDescriptor).gq = function () {
  return this.d11_1;
};
protoOf(NothingSerialDescriptor).br = function () {
  return 0;
};
protoOf(NothingSerialDescriptor).dr = function (index) {
  error(this);
};
protoOf(NothingSerialDescriptor).er = function (name) {
  error(this);
};
protoOf(NothingSerialDescriptor).hr = function (index) {
  error(this);
};
protoOf(NothingSerialDescriptor).gr = function (index) {
  error(this);
};
protoOf(NothingSerialDescriptor).fr = function (index) {
  error(this);
};
protoOf(NothingSerialDescriptor).toString = function () {
  return 'NothingSerialDescriptor';
};
protoOf(NothingSerialDescriptor).equals = function (other) {
  return this === other;
};
protoOf(NothingSerialDescriptor).hashCode = function () {
  return getStringHashCode(this.d11_1) + imul(31, this.c11_1.hashCode()) | 0;
};
var NothingSerialDescriptor_instance;
function NothingSerialDescriptor_getInstance() {
  if (NothingSerialDescriptor_instance == null)
    new NothingSerialDescriptor();
  return NothingSerialDescriptor_instance;
}
function NullableSerializer(serializer) {
  this.e11_1 = serializer;
  this.f11_1 = new SerialDescriptorForNullable(this.e11_1.fp());
}
protoOf(NullableSerializer).fp = function () {
  return this.f11_1;
};
protoOf(NullableSerializer).g11 = function (encoder, value) {
  if (!(value == null)) {
    encoder.nu();
    encoder.ku(this.e11_1, value);
  } else {
    encoder.nt();
  }
};
protoOf(NullableSerializer).gp = function (encoder, value) {
  return this.g11(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(NullableSerializer).hp = function (decoder) {
  return decoder.ds() ? decoder.rs(this.e11_1) : decoder.es();
};
protoOf(NullableSerializer).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof NullableSerializer))
    THROW_CCE();
  if (!equals(this.e11_1, other.e11_1))
    return false;
  return true;
};
protoOf(NullableSerializer).hashCode = function () {
  return hashCode(this.e11_1);
};
function SerialDescriptorForNullable(original) {
  this.tq_1 = original;
  this.uq_1 = this.tq_1.gq() + '?';
  this.vq_1 = cachedSerialNames(this.tq_1);
}
protoOf(SerialDescriptorForNullable).gq = function () {
  return this.uq_1;
};
protoOf(SerialDescriptorForNullable).bs = function () {
  return this.vq_1;
};
protoOf(SerialDescriptorForNullable).sq = function () {
  return true;
};
protoOf(SerialDescriptorForNullable).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SerialDescriptorForNullable))
    return false;
  if (!equals(this.tq_1, other.tq_1))
    return false;
  return true;
};
protoOf(SerialDescriptorForNullable).toString = function () {
  return toString(this.tq_1) + '?';
};
protoOf(SerialDescriptorForNullable).hashCode = function () {
  return imul(hashCode(this.tq_1), 31);
};
protoOf(SerialDescriptorForNullable).zq = function () {
  return this.tq_1.zq();
};
protoOf(SerialDescriptorForNullable).ar = function () {
  return this.tq_1.ar();
};
protoOf(SerialDescriptorForNullable).br = function () {
  return this.tq_1.br();
};
protoOf(SerialDescriptorForNullable).cr = function () {
  return this.tq_1.cr();
};
protoOf(SerialDescriptorForNullable).dr = function (index) {
  return this.tq_1.dr(index);
};
protoOf(SerialDescriptorForNullable).er = function (name) {
  return this.tq_1.er(name);
};
protoOf(SerialDescriptorForNullable).fr = function (index) {
  return this.tq_1.fr(index);
};
protoOf(SerialDescriptorForNullable).gr = function (index) {
  return this.tq_1.gr(index);
};
protoOf(SerialDescriptorForNullable).hr = function (index) {
  return this.tq_1.hr(index);
};
function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.np_1 = this$0.i11_1;
    return Unit_instance;
  };
}
function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
  return function () {
    var tmp = OBJECT_getInstance();
    return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
  };
}
function ObjectSerializer$_get_descriptor_$ref_7z4xb6() {
  return function (p0) {
    return p0.fp();
  };
}
function ObjectSerializer(serialName, objectInstance) {
  this.h11_1 = objectInstance;
  this.i11_1 = emptyList();
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.j11_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
}
protoOf(ObjectSerializer).fp = function () {
  var tmp0 = this.j11_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('descriptor', 1, tmp, ObjectSerializer$_get_descriptor_$ref_7z4xb6(), null);
  return tmp0.w();
};
protoOf(ObjectSerializer).xp = function (encoder, value) {
  encoder.ss(this.fp()).ts(this.fp());
};
protoOf(ObjectSerializer).gp = function (encoder, value) {
  return this.xp(encoder, !(value == null) ? value : THROW_CCE());
};
protoOf(ObjectSerializer).hp = function (decoder) {
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.fp();
  var composite = decoder.ss(descriptor);
  var tmp$ret$0;
  $l$block_0: {
    if (composite.it()) {
      tmp$ret$0 = Unit_instance;
      break $l$block_0;
    }
    var index = composite.jt(this.fp());
    if (index === -1) {
      tmp$ret$0 = Unit_instance;
      break $l$block_0;
    } else
      throw SerializationException_init_$Create$_0('Unexpected index ' + index);
  }
  var result = tmp$ret$0;
  composite.ts(descriptor);
  return this.h11_1;
};
function get_EMPTY_DESCRIPTOR_ARRAY() {
  _init_properties_Platform_common_kt__3qzecs();
  return EMPTY_DESCRIPTOR_ARRAY;
}
var EMPTY_DESCRIPTOR_ARRAY;
function kclass(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var t = _this__u8e3s4.sa();
  var tmp;
  if (!(t == null) ? isInterface(t, KClass) : false) {
    tmp = t;
  } else {
    if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
      throw IllegalArgumentException_init_$Create$('Captured type parameter ' + toString(t) + ' from generic non-reified function. ' + ('Such functionality cannot be supported because ' + toString(t) + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + toString(t) + '.'));
    } else {
      throw IllegalArgumentException_init_$Create$('Only KClass supported as classifier, got ' + toString_0(t));
    }
  }
  var tmp_0 = tmp;
  return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
}
function typeOrThrow(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var tmp0 = _this__u8e3s4.xj_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.requireNotNull' call
    if (tmp0 == null) {
      var message = 'Star projections in type arguments are not allowed, but had ' + toString_0(_this__u8e3s4.xj_1);
      throw IllegalArgumentException_init_$Create$(toString(message));
    } else {
      tmp$ret$1 = tmp0;
      break $l$block;
    }
  }
  return tmp$ret$1;
}
function compactArray(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  if (!(_this__u8e3s4 == null || _this__u8e3s4.q())) {
    tmp = _this__u8e3s4;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_0 = copyToArray(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
}
function cachedSerialNames(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  if (isInterface(_this__u8e3s4, CachedNames))
    return _this__u8e3s4.bs();
  var result = HashSet_init_$Create$_1(_this__u8e3s4.br());
  var inductionVariable = 0;
  var last = _this__u8e3s4.br();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      var element = _this__u8e3s4.dr(i);
      result.j(element);
    }
     while (inductionVariable < last);
  return result;
}
function notRegisteredMessage(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var tmp0_elvis_lhs = _this__u8e3s4.ea();
  return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
}
function notRegisteredMessage_0(className) {
  _init_properties_Platform_common_kt__3qzecs();
  return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
}
function serializerNotRegistered(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4));
}
var properties_initialized_Platform_common_kt_i7q4ty;
function _init_properties_Platform_common_kt__3qzecs() {
  if (!properties_initialized_Platform_common_kt_i7q4ty) {
    properties_initialized_Platform_common_kt_i7q4ty = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_DESCRIPTOR_ARRAY = [];
  }
}
function throwMissingFieldException(seen, goldenMask, descriptor) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var missingFields = ArrayList_init_$Create$_0();
  var missingFieldsBits = goldenMask & ~seen;
  var inductionVariable = 0;
  if (inductionVariable < 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!((missingFieldsBits & 1) === 0)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element = descriptor.dr(i);
        missingFields.j(element);
      }
      missingFieldsBits = missingFieldsBits >>> 1 | 0;
    }
     while (inductionVariable < 32);
  throw MissingFieldException_init_$Create$(missingFields, descriptor.gq());
}
function _get_childSerializers__7vnyfa($this) {
  var tmp0 = $this.lz_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('childSerializers', 1, tmp, PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca(), null);
  return tmp0.w();
}
function _get__hashCode__tgwhef_0($this) {
  var tmp0 = $this.nz_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_hashCode', 1, tmp, PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz(), null);
  return tmp0.w();
}
function buildIndices($this) {
  var indices = HashMap_init_$Create$();
  var inductionVariable = 0;
  var last = $this.gz_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = $this.gz_1[i];
      indices.a2(key, i);
    }
     while (inductionVariable <= last);
  return indices;
}
function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.dz_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z10();
    return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
  };
}
function PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca() {
  return function (p0) {
    return _get_childSerializers__7vnyfa(p0);
  };
}
function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.dz_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a11();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(tmp1_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$0 = item.fp();
        destination.j(tmp$ret$0);
      }
      tmp = destination;
    }
    return compactArray(tmp);
  };
}
function PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka() {
  return function (p0) {
    return p0.j10();
  };
}
function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
  return function () {
    return hashCodeImpl(this$0, this$0.j10());
  };
}
function PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz() {
  return function (p0) {
    return _get__hashCode__tgwhef_0(p0);
  };
}
function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
  generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
  this.cz_1 = serialName;
  this.dz_1 = generatedSerializer;
  this.ez_1 = elementsCount;
  this.fz_1 = -1;
  var tmp = this;
  var tmp_0 = 0;
  var tmp_1 = this.ez_1;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_2 = Array(tmp_1);
  while (tmp_0 < tmp_1) {
    tmp_2[tmp_0] = '[UNINITIALIZED]';
    tmp_0 = tmp_0 + 1 | 0;
  }
  tmp.gz_1 = tmp_2;
  var tmp_3 = this;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this.ez_1;
  tmp_3.hz_1 = Array(size);
  this.iz_1 = null;
  this.jz_1 = booleanArray(this.ez_1);
  this.kz_1 = emptyMap();
  var tmp_4 = this;
  var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp_4.lz_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
  var tmp_6 = this;
  var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp_6.mz_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
  var tmp_8 = this;
  var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp_8.nz_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
}
protoOf(PluginGeneratedSerialDescriptor).gq = function () {
  return this.cz_1;
};
protoOf(PluginGeneratedSerialDescriptor).br = function () {
  return this.ez_1;
};
protoOf(PluginGeneratedSerialDescriptor).zq = function () {
  return CLASS_getInstance();
};
protoOf(PluginGeneratedSerialDescriptor).cr = function () {
  var tmp0_elvis_lhs = this.iz_1;
  return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
};
protoOf(PluginGeneratedSerialDescriptor).bs = function () {
  return this.kz_1.d2();
};
protoOf(PluginGeneratedSerialDescriptor).j10 = function () {
  var tmp0 = this.mz_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('typeParameterDescriptors', 1, tmp, PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka(), null);
  return tmp0.w();
};
protoOf(PluginGeneratedSerialDescriptor).k10 = function (name, isOptional) {
  this.fz_1 = this.fz_1 + 1 | 0;
  this.gz_1[this.fz_1] = name;
  this.jz_1[this.fz_1] = isOptional;
  this.hz_1[this.fz_1] = null;
  if (this.fz_1 === (this.ez_1 - 1 | 0)) {
    this.kz_1 = buildIndices(this);
  }
};
protoOf(PluginGeneratedSerialDescriptor).pz = function (name, isOptional, $super) {
  isOptional = isOptional === VOID ? false : isOptional;
  var tmp;
  if ($super === VOID) {
    this.k10(name, isOptional);
    tmp = Unit_instance;
  } else {
    tmp = $super.k10.call(this, name, isOptional);
  }
  return tmp;
};
protoOf(PluginGeneratedSerialDescriptor).qz = function (annotation) {
  // Inline function 'kotlin.let' call
  var it = this.hz_1[this.fz_1];
  var tmp;
  if (it == null) {
    var result = ArrayList_init_$Create$(1);
    this.hz_1[this.fz_1] = result;
    tmp = result;
  } else {
    tmp = it;
  }
  var list = tmp;
  list.j(annotation);
};
protoOf(PluginGeneratedSerialDescriptor).oz = function (a) {
  if (this.iz_1 == null) {
    this.iz_1 = ArrayList_init_$Create$(1);
  }
  ensureNotNull(this.iz_1).j(a);
};
protoOf(PluginGeneratedSerialDescriptor).gr = function (index) {
  return getChecked(_get_childSerializers__7vnyfa(this), index).fp();
};
protoOf(PluginGeneratedSerialDescriptor).hr = function (index) {
  return getChecked_0(this.jz_1, index);
};
protoOf(PluginGeneratedSerialDescriptor).fr = function (index) {
  var tmp0_elvis_lhs = getChecked(this.hz_1, index);
  return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
};
protoOf(PluginGeneratedSerialDescriptor).dr = function (index) {
  return getChecked(this.gz_1, index);
};
protoOf(PluginGeneratedSerialDescriptor).er = function (name) {
  var tmp0_elvis_lhs = this.kz_1.h2(name);
  return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
};
protoOf(PluginGeneratedSerialDescriptor).equals = function (other) {
  var tmp$ret$0;
  $l$block_5: {
    // Inline function 'kotlinx.serialization.internal.equalsImpl' call
    if (this === other) {
      tmp$ret$0 = true;
      break $l$block_5;
    }
    if (!(other instanceof PluginGeneratedSerialDescriptor)) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.gq() === other.gq())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!contentEquals(this.j10(), other.j10())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    if (!(this.br() === other.br())) {
      tmp$ret$0 = false;
      break $l$block_5;
    }
    var inductionVariable = 0;
    var last = this.br();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.gr(index).gq() === other.gr(index).gq())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
        if (!equals(this.gr(index).zq(), other.gr(index).zq())) {
          tmp$ret$0 = false;
          break $l$block_5;
        }
      }
       while (inductionVariable < last);
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
};
protoOf(PluginGeneratedSerialDescriptor).hashCode = function () {
  return _get__hashCode__tgwhef_0(this);
};
protoOf(PluginGeneratedSerialDescriptor).toString = function () {
  return toStringImpl(this);
};
function hashCodeImpl(_this__u8e3s4, typeParams) {
  var result = getStringHashCode(_this__u8e3s4.gq());
  result = imul(31, result) + contentHashCode(typeParams) | 0;
  var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 1;
  var _iterator__ex2g4s = elementDescriptors.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    var hash = accumulator;
    var tmp = imul(31, hash);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = element.gq();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  var namesHash = accumulator;
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator_0 = 1;
  var _iterator__ex2g4s_0 = elementDescriptors.l();
  while (_iterator__ex2g4s_0.m()) {
    var element_0 = _iterator__ex2g4s_0.n();
    var hash_0 = accumulator_0;
    var tmp_0 = imul(31, hash_0);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = element_0.zq();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
  }
  var kindHash = accumulator_0;
  result = imul(31, result) + namesHash | 0;
  result = imul(31, result) + kindHash | 0;
  return result;
}
function toStringImpl(_this__u8e3s4) {
  var tmp = until(0, _this__u8e3s4.br());
  var tmp_0 = _this__u8e3s4.gq() + '(';
  return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, toStringImpl$lambda(_this__u8e3s4));
}
function toStringImpl$lambda($this_toStringImpl) {
  return function (i) {
    return $this_toStringImpl.dr(i) + ': ' + $this_toStringImpl.gr(i).gq();
  };
}
function get_EMPTY_SERIALIZER_ARRAY() {
  _init_properties_PluginHelperInterfaces_kt__xgvzfp();
  return EMPTY_SERIALIZER_ARRAY;
}
var EMPTY_SERIALIZER_ARRAY;
function GeneratedSerializer() {
}
function SerializerFactory() {
}
var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
  if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
    properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_SERIALIZER_ARRAY = [];
  }
}
function CharArraySerializer_0() {
  CharArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_11(Companion_getInstance_2()));
}
protoOf(CharArraySerializer_0).n11 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(CharArraySerializer_0).fx = function (_this__u8e3s4) {
  return this.n11((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(CharArraySerializer_0).o11 = function (_this__u8e3s4) {
  return new CharArrayBuilder(_this__u8e3s4);
};
protoOf(CharArraySerializer_0).aw = function (_this__u8e3s4) {
  return this.o11((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(CharArraySerializer_0).qy = function () {
  return charArray(0);
};
protoOf(CharArraySerializer_0).p11 = function (decoder, index, builder, checkIndex) {
  builder.s11(decoder.bt(this.hy_1, index));
};
protoOf(CharArraySerializer_0).lw = function (decoder, index, builder, checkIndex) {
  return this.p11(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(CharArraySerializer_0).ry = function (decoder, index, builder, checkIndex) {
  return this.p11(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(CharArraySerializer_0).t11 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.gu(this.hy_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(CharArraySerializer_0).sy = function (encoder, content, size) {
  return this.t11(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
};
var CharArraySerializer_instance;
function CharArraySerializer_getInstance() {
  if (CharArraySerializer_instance == null)
    new CharArraySerializer_0();
  return CharArraySerializer_instance;
}
function DoubleArraySerializer_0() {
  DoubleArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_12(DoubleCompanionObject_instance));
}
protoOf(DoubleArraySerializer_0).w11 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(DoubleArraySerializer_0).fx = function (_this__u8e3s4) {
  return this.w11((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(DoubleArraySerializer_0).x11 = function (_this__u8e3s4) {
  return new DoubleArrayBuilder(_this__u8e3s4);
};
protoOf(DoubleArraySerializer_0).aw = function (_this__u8e3s4) {
  return this.x11((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(DoubleArraySerializer_0).qy = function () {
  return new Float64Array(0);
};
protoOf(DoubleArraySerializer_0).y11 = function (decoder, index, builder, checkIndex) {
  builder.b12(decoder.at(this.hy_1, index));
};
protoOf(DoubleArraySerializer_0).lw = function (decoder, index, builder, checkIndex) {
  return this.y11(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(DoubleArraySerializer_0).ry = function (decoder, index, builder, checkIndex) {
  return this.y11(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(DoubleArraySerializer_0).c12 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.fu(this.hy_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(DoubleArraySerializer_0).sy = function (encoder, content, size) {
  return this.c12(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
};
var DoubleArraySerializer_instance;
function DoubleArraySerializer_getInstance() {
  if (DoubleArraySerializer_instance == null)
    new DoubleArraySerializer_0();
  return DoubleArraySerializer_instance;
}
function FloatArraySerializer_0() {
  FloatArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_13(FloatCompanionObject_instance));
}
protoOf(FloatArraySerializer_0).f12 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(FloatArraySerializer_0).fx = function (_this__u8e3s4) {
  return this.f12((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(FloatArraySerializer_0).g12 = function (_this__u8e3s4) {
  return new FloatArrayBuilder(_this__u8e3s4);
};
protoOf(FloatArraySerializer_0).aw = function (_this__u8e3s4) {
  return this.g12((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(FloatArraySerializer_0).qy = function () {
  return new Float32Array(0);
};
protoOf(FloatArraySerializer_0).h12 = function (decoder, index, builder, checkIndex) {
  builder.k12(decoder.zs(this.hy_1, index));
};
protoOf(FloatArraySerializer_0).lw = function (decoder, index, builder, checkIndex) {
  return this.h12(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(FloatArraySerializer_0).ry = function (decoder, index, builder, checkIndex) {
  return this.h12(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(FloatArraySerializer_0).l12 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.eu(this.hy_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(FloatArraySerializer_0).sy = function (encoder, content, size) {
  return this.l12(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
};
var FloatArraySerializer_instance;
function FloatArraySerializer_getInstance() {
  if (FloatArraySerializer_instance == null)
    new FloatArraySerializer_0();
  return FloatArraySerializer_instance;
}
function LongArraySerializer_0() {
  LongArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_7(Companion_instance));
}
protoOf(LongArraySerializer_0).o12 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(LongArraySerializer_0).fx = function (_this__u8e3s4) {
  return this.o12((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LongArraySerializer_0).p12 = function (_this__u8e3s4) {
  return new LongArrayBuilder(_this__u8e3s4);
};
protoOf(LongArraySerializer_0).aw = function (_this__u8e3s4) {
  return this.p12((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(LongArraySerializer_0).qy = function () {
  return longArray(0);
};
protoOf(LongArraySerializer_0).q12 = function (decoder, index, builder, checkIndex) {
  builder.t12(decoder.ys(this.hy_1, index));
};
protoOf(LongArraySerializer_0).lw = function (decoder, index, builder, checkIndex) {
  return this.q12(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(LongArraySerializer_0).ry = function (decoder, index, builder, checkIndex) {
  return this.q12(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(LongArraySerializer_0).u12 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.du(this.hy_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(LongArraySerializer_0).sy = function (encoder, content, size) {
  return this.u12(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
};
var LongArraySerializer_instance;
function LongArraySerializer_getInstance() {
  if (LongArraySerializer_instance == null)
    new LongArraySerializer_0();
  return LongArraySerializer_instance;
}
function ULongArraySerializer_0() {
  ULongArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_3(Companion_getInstance_3()));
}
protoOf(ULongArraySerializer_0).x12 = function (_this__u8e3s4) {
  return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
};
protoOf(ULongArraySerializer_0).fx = function (_this__u8e3s4) {
  return this.x12(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.so_1 : THROW_CCE());
};
protoOf(ULongArraySerializer_0).y12 = function (_this__u8e3s4) {
  return new ULongArrayBuilder(_this__u8e3s4);
};
protoOf(ULongArraySerializer_0).aw = function (_this__u8e3s4) {
  return this.y12(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.so_1 : THROW_CCE());
};
protoOf(ULongArraySerializer_0).z12 = function () {
  return _ULongArray___init__impl__twm1l3(0);
};
protoOf(ULongArraySerializer_0).qy = function () {
  return new ULongArray(this.z12());
};
protoOf(ULongArraySerializer_0).a13 = function (decoder, index, builder, checkIndex) {
  // Inline function 'kotlin.toULong' call
  var this_0 = decoder.dt(this.hy_1, index).js();
  var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
  builder.d13(tmp$ret$0);
};
protoOf(ULongArraySerializer_0).lw = function (decoder, index, builder, checkIndex) {
  return this.a13(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ULongArraySerializer_0).ry = function (decoder, index, builder, checkIndex) {
  return this.a13(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ULongArraySerializer_0).e13 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = encoder.iu(this.hy_1, i);
      // Inline function 'kotlin.ULong.toLong' call
      var this_0 = ULongArray__get_impl_pr71q9(content, i);
      var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
      tmp.st(tmp$ret$0);
    }
     while (inductionVariable < size);
};
protoOf(ULongArraySerializer_0).sy = function (encoder, content, size) {
  return this.e13(encoder, content instanceof ULongArray ? content.so_1 : THROW_CCE(), size);
};
var ULongArraySerializer_instance;
function ULongArraySerializer_getInstance() {
  if (ULongArraySerializer_instance == null)
    new ULongArraySerializer_0();
  return ULongArraySerializer_instance;
}
function IntArraySerializer_0() {
  IntArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_8(IntCompanionObject_instance));
}
protoOf(IntArraySerializer_0).h13 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(IntArraySerializer_0).fx = function (_this__u8e3s4) {
  return this.h13((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(IntArraySerializer_0).i13 = function (_this__u8e3s4) {
  return new IntArrayBuilder(_this__u8e3s4);
};
protoOf(IntArraySerializer_0).aw = function (_this__u8e3s4) {
  return this.i13((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(IntArraySerializer_0).qy = function () {
  return new Int32Array(0);
};
protoOf(IntArraySerializer_0).j13 = function (decoder, index, builder, checkIndex) {
  builder.m13(decoder.xs(this.hy_1, index));
};
protoOf(IntArraySerializer_0).lw = function (decoder, index, builder, checkIndex) {
  return this.j13(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(IntArraySerializer_0).ry = function (decoder, index, builder, checkIndex) {
  return this.j13(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(IntArraySerializer_0).n13 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.cu(this.hy_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(IntArraySerializer_0).sy = function (encoder, content, size) {
  return this.n13(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
};
var IntArraySerializer_instance;
function IntArraySerializer_getInstance() {
  if (IntArraySerializer_instance == null)
    new IntArraySerializer_0();
  return IntArraySerializer_instance;
}
function UIntArraySerializer_0() {
  UIntArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_4(Companion_getInstance_4()));
}
protoOf(UIntArraySerializer_0).q13 = function (_this__u8e3s4) {
  return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
};
protoOf(UIntArraySerializer_0).fx = function (_this__u8e3s4) {
  return this.q13(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.ho_1 : THROW_CCE());
};
protoOf(UIntArraySerializer_0).r13 = function (_this__u8e3s4) {
  return new UIntArrayBuilder(_this__u8e3s4);
};
protoOf(UIntArraySerializer_0).aw = function (_this__u8e3s4) {
  return this.r13(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.ho_1 : THROW_CCE());
};
protoOf(UIntArraySerializer_0).s13 = function () {
  return _UIntArray___init__impl__ghjpc6(0);
};
protoOf(UIntArraySerializer_0).qy = function () {
  return new UIntArray(this.s13());
};
protoOf(UIntArraySerializer_0).t13 = function (decoder, index, builder, checkIndex) {
  // Inline function 'kotlin.toUInt' call
  var this_0 = decoder.dt(this.hy_1, index).is();
  var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
  builder.w13(tmp$ret$0);
};
protoOf(UIntArraySerializer_0).lw = function (decoder, index, builder, checkIndex) {
  return this.t13(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UIntArraySerializer_0).ry = function (decoder, index, builder, checkIndex) {
  return this.t13(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UIntArraySerializer_0).x13 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = encoder.iu(this.hy_1, i);
      // Inline function 'kotlin.UInt.toInt' call
      var this_0 = UIntArray__get_impl_gp5kza(content, i);
      var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
      tmp.rt(tmp$ret$0);
    }
     while (inductionVariable < size);
};
protoOf(UIntArraySerializer_0).sy = function (encoder, content, size) {
  return this.x13(encoder, content instanceof UIntArray ? content.ho_1 : THROW_CCE(), size);
};
var UIntArraySerializer_instance;
function UIntArraySerializer_getInstance() {
  if (UIntArraySerializer_instance == null)
    new UIntArraySerializer_0();
  return UIntArraySerializer_instance;
}
function ShortArraySerializer_0() {
  ShortArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_10(ShortCompanionObject_instance));
}
protoOf(ShortArraySerializer_0).a14 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(ShortArraySerializer_0).fx = function (_this__u8e3s4) {
  return this.a14((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ShortArraySerializer_0).b14 = function (_this__u8e3s4) {
  return new ShortArrayBuilder(_this__u8e3s4);
};
protoOf(ShortArraySerializer_0).aw = function (_this__u8e3s4) {
  return this.b14((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ShortArraySerializer_0).qy = function () {
  return new Int16Array(0);
};
protoOf(ShortArraySerializer_0).c14 = function (decoder, index, builder, checkIndex) {
  builder.f14(decoder.ws(this.hy_1, index));
};
protoOf(ShortArraySerializer_0).lw = function (decoder, index, builder, checkIndex) {
  return this.c14(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ShortArraySerializer_0).ry = function (decoder, index, builder, checkIndex) {
  return this.c14(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ShortArraySerializer_0).g14 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.bu(this.hy_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(ShortArraySerializer_0).sy = function (encoder, content, size) {
  return this.g14(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
};
var ShortArraySerializer_instance;
function ShortArraySerializer_getInstance() {
  if (ShortArraySerializer_instance == null)
    new ShortArraySerializer_0();
  return ShortArraySerializer_instance;
}
function UShortArraySerializer_0() {
  UShortArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_6(Companion_getInstance_5()));
}
protoOf(UShortArraySerializer_0).j14 = function (_this__u8e3s4) {
  return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
};
protoOf(UShortArraySerializer_0).fx = function (_this__u8e3s4) {
  return this.j14(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.dp_1 : THROW_CCE());
};
protoOf(UShortArraySerializer_0).k14 = function (_this__u8e3s4) {
  return new UShortArrayBuilder(_this__u8e3s4);
};
protoOf(UShortArraySerializer_0).aw = function (_this__u8e3s4) {
  return this.k14(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.dp_1 : THROW_CCE());
};
protoOf(UShortArraySerializer_0).l14 = function () {
  return _UShortArray___init__impl__9b26ef(0);
};
protoOf(UShortArraySerializer_0).qy = function () {
  return new UShortArray(this.l14());
};
protoOf(UShortArraySerializer_0).m14 = function (decoder, index, builder, checkIndex) {
  // Inline function 'kotlin.toUShort' call
  var this_0 = decoder.dt(this.hy_1, index).hs();
  var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
  builder.p14(tmp$ret$0);
};
protoOf(UShortArraySerializer_0).lw = function (decoder, index, builder, checkIndex) {
  return this.m14(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UShortArraySerializer_0).ry = function (decoder, index, builder, checkIndex) {
  return this.m14(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UShortArraySerializer_0).q14 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = encoder.iu(this.hy_1, i);
      // Inline function 'kotlin.UShort.toShort' call
      var this_0 = UShortArray__get_impl_fnbhmx(content, i);
      var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
      tmp.qt(tmp$ret$0);
    }
     while (inductionVariable < size);
};
protoOf(UShortArraySerializer_0).sy = function (encoder, content, size) {
  return this.q14(encoder, content instanceof UShortArray ? content.dp_1 : THROW_CCE(), size);
};
var UShortArraySerializer_instance;
function UShortArraySerializer_getInstance() {
  if (UShortArraySerializer_instance == null)
    new UShortArraySerializer_0();
  return UShortArraySerializer_instance;
}
function ByteArraySerializer_0() {
  ByteArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_9(ByteCompanionObject_instance));
}
protoOf(ByteArraySerializer_0).t14 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(ByteArraySerializer_0).fx = function (_this__u8e3s4) {
  return this.t14((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ByteArraySerializer_0).u14 = function (_this__u8e3s4) {
  return new ByteArrayBuilder(_this__u8e3s4);
};
protoOf(ByteArraySerializer_0).aw = function (_this__u8e3s4) {
  return this.u14((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(ByteArraySerializer_0).qy = function () {
  return new Int8Array(0);
};
protoOf(ByteArraySerializer_0).v14 = function (decoder, index, builder, checkIndex) {
  builder.y14(decoder.vs(this.hy_1, index));
};
protoOf(ByteArraySerializer_0).lw = function (decoder, index, builder, checkIndex) {
  return this.v14(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ByteArraySerializer_0).ry = function (decoder, index, builder, checkIndex) {
  return this.v14(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(ByteArraySerializer_0).z14 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.au(this.hy_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(ByteArraySerializer_0).sy = function (encoder, content, size) {
  return this.z14(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
};
var ByteArraySerializer_instance;
function ByteArraySerializer_getInstance() {
  if (ByteArraySerializer_instance == null)
    new ByteArraySerializer_0();
  return ByteArraySerializer_instance;
}
function UByteArraySerializer_0() {
  UByteArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_5(Companion_getInstance_6()));
}
protoOf(UByteArraySerializer_0).c15 = function (_this__u8e3s4) {
  return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
};
protoOf(UByteArraySerializer_0).fx = function (_this__u8e3s4) {
  return this.c15(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.wn_1 : THROW_CCE());
};
protoOf(UByteArraySerializer_0).d15 = function (_this__u8e3s4) {
  return new UByteArrayBuilder(_this__u8e3s4);
};
protoOf(UByteArraySerializer_0).aw = function (_this__u8e3s4) {
  return this.d15(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.wn_1 : THROW_CCE());
};
protoOf(UByteArraySerializer_0).e15 = function () {
  return _UByteArray___init__impl__ip4y9n(0);
};
protoOf(UByteArraySerializer_0).qy = function () {
  return new UByteArray(this.e15());
};
protoOf(UByteArraySerializer_0).f15 = function (decoder, index, builder, checkIndex) {
  // Inline function 'kotlin.toUByte' call
  var this_0 = decoder.dt(this.hy_1, index).gs();
  var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
  builder.i15(tmp$ret$0);
};
protoOf(UByteArraySerializer_0).lw = function (decoder, index, builder, checkIndex) {
  return this.f15(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UByteArraySerializer_0).ry = function (decoder, index, builder, checkIndex) {
  return this.f15(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(UByteArraySerializer_0).j15 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = encoder.iu(this.hy_1, i);
      // Inline function 'kotlin.UByte.toByte' call
      var this_0 = UByteArray__get_impl_t5f3hv(content, i);
      var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
      tmp.pt(tmp$ret$0);
    }
     while (inductionVariable < size);
};
protoOf(UByteArraySerializer_0).sy = function (encoder, content, size) {
  return this.j15(encoder, content instanceof UByteArray ? content.wn_1 : THROW_CCE(), size);
};
var UByteArraySerializer_instance;
function UByteArraySerializer_getInstance() {
  if (UByteArraySerializer_instance == null)
    new UByteArraySerializer_0();
  return UByteArraySerializer_instance;
}
function BooleanArraySerializer_0() {
  BooleanArraySerializer_instance = this;
  PrimitiveArraySerializer.call(this, serializer_14(BooleanCompanionObject_instance));
}
protoOf(BooleanArraySerializer_0).m15 = function (_this__u8e3s4) {
  return _this__u8e3s4.length;
};
protoOf(BooleanArraySerializer_0).fx = function (_this__u8e3s4) {
  return this.m15((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(BooleanArraySerializer_0).n15 = function (_this__u8e3s4) {
  return new BooleanArrayBuilder(_this__u8e3s4);
};
protoOf(BooleanArraySerializer_0).aw = function (_this__u8e3s4) {
  return this.n15((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(BooleanArraySerializer_0).qy = function () {
  return booleanArray(0);
};
protoOf(BooleanArraySerializer_0).o15 = function (decoder, index, builder, checkIndex) {
  builder.r15(decoder.us(this.hy_1, index));
};
protoOf(BooleanArraySerializer_0).lw = function (decoder, index, builder, checkIndex) {
  return this.o15(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(BooleanArraySerializer_0).ry = function (decoder, index, builder, checkIndex) {
  return this.o15(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
};
protoOf(BooleanArraySerializer_0).s15 = function (encoder, content, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      encoder.zt(this.hy_1, i, content[i]);
    }
     while (inductionVariable < size);
};
protoOf(BooleanArraySerializer_0).sy = function (encoder, content, size) {
  return this.s15(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
};
var BooleanArraySerializer_instance;
function BooleanArraySerializer_getInstance() {
  if (BooleanArraySerializer_instance == null)
    new BooleanArraySerializer_0();
  return BooleanArraySerializer_instance;
}
function CharArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.q11_1 = bufferWithData;
  this.r11_1 = bufferWithData.length;
  this.ny(10);
}
protoOf(CharArrayBuilder).jy = function () {
  return this.r11_1;
};
protoOf(CharArrayBuilder).ny = function (requiredCapacity) {
  if (this.q11_1.length < requiredCapacity)
    this.q11_1 = copyOf(this.q11_1, coerceAtLeast(requiredCapacity, imul(this.q11_1.length, 2)));
};
protoOf(CharArrayBuilder).s11 = function (c) {
  this.uy();
  var tmp = this.q11_1;
  var _unary__edvuaz = this.r11_1;
  this.r11_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(CharArrayBuilder).ly = function () {
  return copyOf(this.q11_1, this.r11_1);
};
function DoubleArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.z11_1 = bufferWithData;
  this.a12_1 = bufferWithData.length;
  this.ny(10);
}
protoOf(DoubleArrayBuilder).jy = function () {
  return this.a12_1;
};
protoOf(DoubleArrayBuilder).ny = function (requiredCapacity) {
  if (this.z11_1.length < requiredCapacity)
    this.z11_1 = copyOf_0(this.z11_1, coerceAtLeast(requiredCapacity, imul(this.z11_1.length, 2)));
};
protoOf(DoubleArrayBuilder).b12 = function (c) {
  this.uy();
  var tmp = this.z11_1;
  var _unary__edvuaz = this.a12_1;
  this.a12_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(DoubleArrayBuilder).ly = function () {
  return copyOf_0(this.z11_1, this.a12_1);
};
function FloatArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.i12_1 = bufferWithData;
  this.j12_1 = bufferWithData.length;
  this.ny(10);
}
protoOf(FloatArrayBuilder).jy = function () {
  return this.j12_1;
};
protoOf(FloatArrayBuilder).ny = function (requiredCapacity) {
  if (this.i12_1.length < requiredCapacity)
    this.i12_1 = copyOf_1(this.i12_1, coerceAtLeast(requiredCapacity, imul(this.i12_1.length, 2)));
};
protoOf(FloatArrayBuilder).k12 = function (c) {
  this.uy();
  var tmp = this.i12_1;
  var _unary__edvuaz = this.j12_1;
  this.j12_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(FloatArrayBuilder).ly = function () {
  return copyOf_1(this.i12_1, this.j12_1);
};
function LongArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.r12_1 = bufferWithData;
  this.s12_1 = bufferWithData.length;
  this.ny(10);
}
protoOf(LongArrayBuilder).jy = function () {
  return this.s12_1;
};
protoOf(LongArrayBuilder).ny = function (requiredCapacity) {
  if (this.r12_1.length < requiredCapacity)
    this.r12_1 = copyOf_2(this.r12_1, coerceAtLeast(requiredCapacity, imul(this.r12_1.length, 2)));
};
protoOf(LongArrayBuilder).t12 = function (c) {
  this.uy();
  var tmp = this.r12_1;
  var _unary__edvuaz = this.s12_1;
  this.s12_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(LongArrayBuilder).ly = function () {
  return copyOf_2(this.r12_1, this.s12_1);
};
function ULongArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.b13_1 = bufferWithData;
  this.c13_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
  this.ny(10);
}
protoOf(ULongArrayBuilder).jy = function () {
  return this.c13_1;
};
protoOf(ULongArrayBuilder).ny = function (requiredCapacity) {
  if (_ULongArray___get_size__impl__ju6dtr(this.b13_1) < requiredCapacity) {
    var tmp = this;
    var tmp0 = this.b13_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.b13_1), 2));
    tmp.b13_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
  }
};
protoOf(ULongArrayBuilder).d13 = function (c) {
  this.uy();
  var tmp = this.b13_1;
  var _unary__edvuaz = this.c13_1;
  this.c13_1 = _unary__edvuaz + 1 | 0;
  ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
};
protoOf(ULongArrayBuilder).t15 = function () {
  var tmp0 = this.b13_1;
  // Inline function 'kotlin.collections.copyOf' call
  var newSize = this.c13_1;
  return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
};
protoOf(ULongArrayBuilder).ly = function () {
  return new ULongArray(this.t15());
};
function IntArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.k13_1 = bufferWithData;
  this.l13_1 = bufferWithData.length;
  this.ny(10);
}
protoOf(IntArrayBuilder).jy = function () {
  return this.l13_1;
};
protoOf(IntArrayBuilder).ny = function (requiredCapacity) {
  if (this.k13_1.length < requiredCapacity)
    this.k13_1 = copyOf_3(this.k13_1, coerceAtLeast(requiredCapacity, imul(this.k13_1.length, 2)));
};
protoOf(IntArrayBuilder).m13 = function (c) {
  this.uy();
  var tmp = this.k13_1;
  var _unary__edvuaz = this.l13_1;
  this.l13_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(IntArrayBuilder).ly = function () {
  return copyOf_3(this.k13_1, this.l13_1);
};
function UIntArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.u13_1 = bufferWithData;
  this.v13_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
  this.ny(10);
}
protoOf(UIntArrayBuilder).jy = function () {
  return this.v13_1;
};
protoOf(UIntArrayBuilder).ny = function (requiredCapacity) {
  if (_UIntArray___get_size__impl__r6l8ci(this.u13_1) < requiredCapacity) {
    var tmp = this;
    var tmp0 = this.u13_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.u13_1), 2));
    tmp.u13_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
  }
};
protoOf(UIntArrayBuilder).w13 = function (c) {
  this.uy();
  var tmp = this.u13_1;
  var _unary__edvuaz = this.v13_1;
  this.v13_1 = _unary__edvuaz + 1 | 0;
  UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
};
protoOf(UIntArrayBuilder).u15 = function () {
  var tmp0 = this.u13_1;
  // Inline function 'kotlin.collections.copyOf' call
  var newSize = this.v13_1;
  return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
};
protoOf(UIntArrayBuilder).ly = function () {
  return new UIntArray(this.u15());
};
function ShortArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.d14_1 = bufferWithData;
  this.e14_1 = bufferWithData.length;
  this.ny(10);
}
protoOf(ShortArrayBuilder).jy = function () {
  return this.e14_1;
};
protoOf(ShortArrayBuilder).ny = function (requiredCapacity) {
  if (this.d14_1.length < requiredCapacity)
    this.d14_1 = copyOf_4(this.d14_1, coerceAtLeast(requiredCapacity, imul(this.d14_1.length, 2)));
};
protoOf(ShortArrayBuilder).f14 = function (c) {
  this.uy();
  var tmp = this.d14_1;
  var _unary__edvuaz = this.e14_1;
  this.e14_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(ShortArrayBuilder).ly = function () {
  return copyOf_4(this.d14_1, this.e14_1);
};
function UShortArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.n14_1 = bufferWithData;
  this.o14_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
  this.ny(10);
}
protoOf(UShortArrayBuilder).jy = function () {
  return this.o14_1;
};
protoOf(UShortArrayBuilder).ny = function (requiredCapacity) {
  if (_UShortArray___get_size__impl__jqto1b(this.n14_1) < requiredCapacity) {
    var tmp = this;
    var tmp0 = this.n14_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.n14_1), 2));
    tmp.n14_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
  }
};
protoOf(UShortArrayBuilder).p14 = function (c) {
  this.uy();
  var tmp = this.n14_1;
  var _unary__edvuaz = this.o14_1;
  this.o14_1 = _unary__edvuaz + 1 | 0;
  UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
};
protoOf(UShortArrayBuilder).v15 = function () {
  var tmp0 = this.n14_1;
  // Inline function 'kotlin.collections.copyOf' call
  var newSize = this.o14_1;
  return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
};
protoOf(UShortArrayBuilder).ly = function () {
  return new UShortArray(this.v15());
};
function ByteArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.w14_1 = bufferWithData;
  this.x14_1 = bufferWithData.length;
  this.ny(10);
}
protoOf(ByteArrayBuilder).jy = function () {
  return this.x14_1;
};
protoOf(ByteArrayBuilder).ny = function (requiredCapacity) {
  if (this.w14_1.length < requiredCapacity)
    this.w14_1 = copyOf_5(this.w14_1, coerceAtLeast(requiredCapacity, imul(this.w14_1.length, 2)));
};
protoOf(ByteArrayBuilder).y14 = function (c) {
  this.uy();
  var tmp = this.w14_1;
  var _unary__edvuaz = this.x14_1;
  this.x14_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(ByteArrayBuilder).ly = function () {
  return copyOf_5(this.w14_1, this.x14_1);
};
function UByteArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.g15_1 = bufferWithData;
  this.h15_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
  this.ny(10);
}
protoOf(UByteArrayBuilder).jy = function () {
  return this.h15_1;
};
protoOf(UByteArrayBuilder).ny = function (requiredCapacity) {
  if (_UByteArray___get_size__impl__h6pkdv(this.g15_1) < requiredCapacity) {
    var tmp = this;
    var tmp0 = this.g15_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.g15_1), 2));
    tmp.g15_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
  }
};
protoOf(UByteArrayBuilder).i15 = function (c) {
  this.uy();
  var tmp = this.g15_1;
  var _unary__edvuaz = this.h15_1;
  this.h15_1 = _unary__edvuaz + 1 | 0;
  UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
};
protoOf(UByteArrayBuilder).w15 = function () {
  var tmp0 = this.g15_1;
  // Inline function 'kotlin.collections.copyOf' call
  var newSize = this.h15_1;
  return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
};
protoOf(UByteArrayBuilder).ly = function () {
  return new UByteArray(this.w15());
};
function BooleanArrayBuilder(bufferWithData) {
  PrimitiveArrayBuilder.call(this);
  this.p15_1 = bufferWithData;
  this.q15_1 = bufferWithData.length;
  this.ny(10);
}
protoOf(BooleanArrayBuilder).jy = function () {
  return this.q15_1;
};
protoOf(BooleanArrayBuilder).ny = function (requiredCapacity) {
  if (this.p15_1.length < requiredCapacity)
    this.p15_1 = copyOf_6(this.p15_1, coerceAtLeast(requiredCapacity, imul(this.p15_1.length, 2)));
};
protoOf(BooleanArrayBuilder).r15 = function (c) {
  this.uy();
  var tmp = this.p15_1;
  var _unary__edvuaz = this.q15_1;
  this.q15_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = c;
};
protoOf(BooleanArrayBuilder).ly = function () {
  return copyOf_6(this.p15_1, this.q15_1);
};
function get_BUILTIN_SERIALIZERS() {
  _init_properties_Primitives_kt__k0eto4();
  return BUILTIN_SERIALIZERS;
}
var BUILTIN_SERIALIZERS;
function LongSerializer() {
  LongSerializer_instance = this;
  this.x15_1 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
}
protoOf(LongSerializer).fp = function () {
  return this.x15_1;
};
protoOf(LongSerializer).y15 = function (encoder, value) {
  return encoder.st(value);
};
protoOf(LongSerializer).gp = function (encoder, value) {
  return this.y15(encoder, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
};
protoOf(LongSerializer).hp = function (decoder) {
  return decoder.js();
};
var LongSerializer_instance;
function LongSerializer_getInstance() {
  if (LongSerializer_instance == null)
    new LongSerializer();
  return LongSerializer_instance;
}
function StringSerializer() {
  StringSerializer_instance = this;
  this.z15_1 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
}
protoOf(StringSerializer).fp = function () {
  return this.z15_1;
};
protoOf(StringSerializer).a16 = function (encoder, value) {
  return encoder.wt(value);
};
protoOf(StringSerializer).gp = function (encoder, value) {
  return this.a16(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
};
protoOf(StringSerializer).hp = function (decoder) {
  return decoder.ns();
};
var StringSerializer_instance;
function StringSerializer_getInstance() {
  if (StringSerializer_instance == null)
    new StringSerializer();
  return StringSerializer_instance;
}
function BooleanSerializer() {
  BooleanSerializer_instance = this;
  this.b16_1 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
}
protoOf(BooleanSerializer).fp = function () {
  return this.b16_1;
};
protoOf(BooleanSerializer).c16 = function (encoder, value) {
  return encoder.ot(value);
};
protoOf(BooleanSerializer).gp = function (encoder, value) {
  return this.c16(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
};
protoOf(BooleanSerializer).hp = function (decoder) {
  return decoder.fs();
};
var BooleanSerializer_instance;
function BooleanSerializer_getInstance() {
  if (BooleanSerializer_instance == null)
    new BooleanSerializer();
  return BooleanSerializer_instance;
}
function IntSerializer() {
  IntSerializer_instance = this;
  this.d16_1 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
}
protoOf(IntSerializer).fp = function () {
  return this.d16_1;
};
protoOf(IntSerializer).e16 = function (encoder, value) {
  return encoder.rt(value);
};
protoOf(IntSerializer).gp = function (encoder, value) {
  return this.e16(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(IntSerializer).hp = function (decoder) {
  return decoder.is();
};
var IntSerializer_instance;
function IntSerializer_getInstance() {
  if (IntSerializer_instance == null)
    new IntSerializer();
  return IntSerializer_instance;
}
function FloatSerializer() {
  FloatSerializer_instance = this;
  this.f16_1 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
}
protoOf(FloatSerializer).fp = function () {
  return this.f16_1;
};
protoOf(FloatSerializer).g16 = function (encoder, value) {
  return encoder.tt(value);
};
protoOf(FloatSerializer).gp = function (encoder, value) {
  return this.g16(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(FloatSerializer).hp = function (decoder) {
  return decoder.ks();
};
var FloatSerializer_instance;
function FloatSerializer_getInstance() {
  if (FloatSerializer_instance == null)
    new FloatSerializer();
  return FloatSerializer_instance;
}
function builtinSerializerOrNull(_this__u8e3s4) {
  _init_properties_Primitives_kt__k0eto4();
  var tmp = get_BUILTIN_SERIALIZERS().h2(_this__u8e3s4);
  return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
}
function PrimitiveDescriptorSafe(serialName, kind) {
  _init_properties_Primitives_kt__k0eto4();
  checkNameIsNotAPrimitive(serialName);
  return new PrimitiveSerialDescriptor_0(serialName, kind);
}
function error_0($this) {
  throw IllegalStateException_init_$Create$('Primitive descriptor ' + $this.h16_1 + ' does not have elements');
}
function PrimitiveSerialDescriptor_0(serialName, kind) {
  this.h16_1 = serialName;
  this.i16_1 = kind;
}
protoOf(PrimitiveSerialDescriptor_0).gq = function () {
  return this.h16_1;
};
protoOf(PrimitiveSerialDescriptor_0).zq = function () {
  return this.i16_1;
};
protoOf(PrimitiveSerialDescriptor_0).br = function () {
  return 0;
};
protoOf(PrimitiveSerialDescriptor_0).dr = function (index) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).er = function (name) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).hr = function (index) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).gr = function (index) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).fr = function (index) {
  error_0(this);
};
protoOf(PrimitiveSerialDescriptor_0).toString = function () {
  return 'PrimitiveDescriptor(' + this.h16_1 + ')';
};
protoOf(PrimitiveSerialDescriptor_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PrimitiveSerialDescriptor_0))
    return false;
  if (this.h16_1 === other.h16_1 && equals(this.i16_1, other.i16_1))
    return true;
  return false;
};
protoOf(PrimitiveSerialDescriptor_0).hashCode = function () {
  return getStringHashCode(this.h16_1) + imul(31, this.i16_1.hashCode()) | 0;
};
function checkNameIsNotAPrimitive(serialName) {
  _init_properties_Primitives_kt__k0eto4();
  var values = get_BUILTIN_SERIALIZERS().e2();
  var _iterator__ex2g4s = values.l();
  while (_iterator__ex2g4s.m()) {
    var primitive = _iterator__ex2g4s.n();
    var primitiveName = primitive.fp().gq();
    if (serialName === primitiveName) {
      throw IllegalArgumentException_init_$Create$(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exists ' + getKClassFromExpression(primitive).ea() + '.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
    }
  }
}
function ByteSerializer() {
  ByteSerializer_instance = this;
  this.j16_1 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
}
protoOf(ByteSerializer).fp = function () {
  return this.j16_1;
};
protoOf(ByteSerializer).k16 = function (encoder, value) {
  return encoder.pt(value);
};
protoOf(ByteSerializer).gp = function (encoder, value) {
  return this.k16(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(ByteSerializer).hp = function (decoder) {
  return decoder.gs();
};
var ByteSerializer_instance;
function ByteSerializer_getInstance() {
  if (ByteSerializer_instance == null)
    new ByteSerializer();
  return ByteSerializer_instance;
}
function ShortSerializer() {
  ShortSerializer_instance = this;
  this.l16_1 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
}
protoOf(ShortSerializer).fp = function () {
  return this.l16_1;
};
protoOf(ShortSerializer).m16 = function (encoder, value) {
  return encoder.qt(value);
};
protoOf(ShortSerializer).gp = function (encoder, value) {
  return this.m16(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(ShortSerializer).hp = function (decoder) {
  return decoder.hs();
};
var ShortSerializer_instance;
function ShortSerializer_getInstance() {
  if (ShortSerializer_instance == null)
    new ShortSerializer();
  return ShortSerializer_instance;
}
function CharSerializer() {
  CharSerializer_instance = this;
  this.n16_1 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
}
protoOf(CharSerializer).fp = function () {
  return this.n16_1;
};
protoOf(CharSerializer).o16 = function (encoder, value) {
  return encoder.vt(value);
};
protoOf(CharSerializer).gp = function (encoder, value) {
  return this.o16(encoder, value instanceof Char ? value.e1_1 : THROW_CCE());
};
protoOf(CharSerializer).p16 = function (decoder) {
  return decoder.ms();
};
protoOf(CharSerializer).hp = function (decoder) {
  return new Char(this.p16(decoder));
};
var CharSerializer_instance;
function CharSerializer_getInstance() {
  if (CharSerializer_instance == null)
    new CharSerializer();
  return CharSerializer_instance;
}
function DoubleSerializer() {
  DoubleSerializer_instance = this;
  this.q16_1 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
}
protoOf(DoubleSerializer).fp = function () {
  return this.q16_1;
};
protoOf(DoubleSerializer).r16 = function (encoder, value) {
  return encoder.ut(value);
};
protoOf(DoubleSerializer).gp = function (encoder, value) {
  return this.r16(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
};
protoOf(DoubleSerializer).hp = function (decoder) {
  return decoder.ls();
};
var DoubleSerializer_instance;
function DoubleSerializer_getInstance() {
  if (DoubleSerializer_instance == null)
    new DoubleSerializer();
  return DoubleSerializer_instance;
}
function UnitSerializer() {
  UnitSerializer_instance = this;
  this.s16_1 = new ObjectSerializer('kotlin.Unit', Unit_instance);
}
protoOf(UnitSerializer).fp = function () {
  return this.s16_1.fp();
};
protoOf(UnitSerializer).t16 = function (encoder, value) {
  this.s16_1.xp(encoder, Unit_instance);
};
protoOf(UnitSerializer).gp = function (encoder, value) {
  return this.t16(encoder, value instanceof Unit ? value : THROW_CCE());
};
protoOf(UnitSerializer).u16 = function (decoder) {
  this.s16_1.hp(decoder);
};
protoOf(UnitSerializer).hp = function (decoder) {
  this.u16(decoder);
  return Unit_instance;
};
var UnitSerializer_instance;
function UnitSerializer_getInstance() {
  if (UnitSerializer_instance == null)
    new UnitSerializer();
  return UnitSerializer_instance;
}
var properties_initialized_Primitives_kt_6dpii6;
function _init_properties_Primitives_kt__k0eto4() {
  if (!properties_initialized_Primitives_kt_6dpii6) {
    properties_initialized_Primitives_kt_6dpii6 = true;
    BUILTIN_SERIALIZERS = initBuiltins();
  }
}
function NamedValueDecoder() {
  TaggedDecoder.call(this);
}
protoOf(NamedValueDecoder).x16 = function (_this__u8e3s4, index) {
  return this.z16(this.y16(_this__u8e3s4, index));
};
protoOf(NamedValueDecoder).z16 = function (nestedName) {
  var tmp0_elvis_lhs = this.c17();
  return this.d17(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
};
protoOf(NamedValueDecoder).y16 = function (descriptor, index) {
  return descriptor.dr(index);
};
protoOf(NamedValueDecoder).d17 = function (parentName, childName) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(parentName) === 0) {
    tmp = childName;
  } else {
    tmp = parentName + '.' + childName;
  }
  return tmp;
};
protoOf(NamedValueDecoder).e17 = function () {
  return this.a17_1.q() ? '$' : joinToString(this.a17_1, '.', '$.');
};
function tagBlock($this, tag, block) {
  $this.s17(tag);
  var r = block();
  if (!$this.b17_1) {
    $this.t17();
  }
  $this.b17_1 = false;
  return r;
}
function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
  return function () {
    return this$0.qs($deserializer, $previousValue);
  };
}
function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
  return function () {
    var tmp0 = this$0;
    // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
    var isNullabilitySupported = $deserializer.fp().sq();
    var tmp;
    if (isNullabilitySupported || tmp0.ds()) {
      tmp = this$0.qs($deserializer, $previousValue);
    } else {
      tmp = tmp0.es();
    }
    return tmp;
  };
}
function TaggedDecoder() {
  var tmp = this;
  // Inline function 'kotlin.collections.arrayListOf' call
  tmp.a17_1 = ArrayList_init_$Create$_0();
  this.b17_1 = false;
}
protoOf(TaggedDecoder).ht = function () {
  return EmptySerializersModule_0();
};
protoOf(TaggedDecoder).f17 = function (tag) {
  throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
};
protoOf(TaggedDecoder).g17 = function (tag) {
  return true;
};
protoOf(TaggedDecoder).h17 = function (tag) {
  var tmp = this.f17(tag);
  return typeof tmp === 'boolean' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).i17 = function (tag) {
  var tmp = this.f17(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).j17 = function (tag) {
  var tmp = this.f17(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).k17 = function (tag) {
  var tmp = this.f17(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).l17 = function (tag) {
  var tmp = this.f17(tag);
  return typeof tmp === 'bigint' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).m17 = function (tag) {
  var tmp = this.f17(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).n17 = function (tag) {
  var tmp = this.f17(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).o17 = function (tag) {
  var tmp = this.f17(tag);
  return tmp instanceof Char ? tmp.e1_1 : THROW_CCE();
};
protoOf(TaggedDecoder).p17 = function (tag) {
  var tmp = this.f17(tag);
  return typeof tmp === 'string' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).q17 = function (tag, enumDescriptor) {
  var tmp = this.f17(tag);
  return typeof tmp === 'number' ? tmp : THROW_CCE();
};
protoOf(TaggedDecoder).r17 = function (tag, inlineDescriptor) {
  // Inline function 'kotlin.apply' call
  this.s17(tag);
  return this;
};
protoOf(TaggedDecoder).qs = function (deserializer, previousValue) {
  return this.rs(deserializer);
};
protoOf(TaggedDecoder).ps = function (descriptor) {
  return this.r17(this.t17(), descriptor);
};
protoOf(TaggedDecoder).ds = function () {
  var tmp0_elvis_lhs = this.c17();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var currentTag = tmp;
  return this.g17(currentTag);
};
protoOf(TaggedDecoder).es = function () {
  return null;
};
protoOf(TaggedDecoder).fs = function () {
  return this.h17(this.t17());
};
protoOf(TaggedDecoder).gs = function () {
  return this.i17(this.t17());
};
protoOf(TaggedDecoder).hs = function () {
  return this.j17(this.t17());
};
protoOf(TaggedDecoder).is = function () {
  return this.k17(this.t17());
};
protoOf(TaggedDecoder).js = function () {
  return this.l17(this.t17());
};
protoOf(TaggedDecoder).ks = function () {
  return this.m17(this.t17());
};
protoOf(TaggedDecoder).ls = function () {
  return this.n17(this.t17());
};
protoOf(TaggedDecoder).ms = function () {
  return this.o17(this.t17());
};
protoOf(TaggedDecoder).ns = function () {
  return this.p17(this.t17());
};
protoOf(TaggedDecoder).os = function (enumDescriptor) {
  return this.q17(this.t17(), enumDescriptor);
};
protoOf(TaggedDecoder).ss = function (descriptor) {
  return this;
};
protoOf(TaggedDecoder).ts = function (descriptor) {
};
protoOf(TaggedDecoder).us = function (descriptor, index) {
  return this.h17(this.x16(descriptor, index));
};
protoOf(TaggedDecoder).vs = function (descriptor, index) {
  return this.i17(this.x16(descriptor, index));
};
protoOf(TaggedDecoder).ws = function (descriptor, index) {
  return this.j17(this.x16(descriptor, index));
};
protoOf(TaggedDecoder).xs = function (descriptor, index) {
  return this.k17(this.x16(descriptor, index));
};
protoOf(TaggedDecoder).ys = function (descriptor, index) {
  return this.l17(this.x16(descriptor, index));
};
protoOf(TaggedDecoder).zs = function (descriptor, index) {
  return this.m17(this.x16(descriptor, index));
};
protoOf(TaggedDecoder).at = function (descriptor, index) {
  return this.n17(this.x16(descriptor, index));
};
protoOf(TaggedDecoder).bt = function (descriptor, index) {
  return this.o17(this.x16(descriptor, index));
};
protoOf(TaggedDecoder).ct = function (descriptor, index) {
  return this.p17(this.x16(descriptor, index));
};
protoOf(TaggedDecoder).dt = function (descriptor, index) {
  return this.r17(this.x16(descriptor, index), descriptor.gr(index));
};
protoOf(TaggedDecoder).et = function (descriptor, index, deserializer, previousValue) {
  var tmp = this.x16(descriptor, index);
  return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
};
protoOf(TaggedDecoder).gt = function (descriptor, index, deserializer, previousValue) {
  var tmp = this.x16(descriptor, index);
  return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
};
protoOf(TaggedDecoder).c17 = function () {
  return lastOrNull(this.a17_1);
};
protoOf(TaggedDecoder).s17 = function (name) {
  this.a17_1.j(name);
};
protoOf(TaggedDecoder).t17 = function () {
  var r = this.a17_1.z1(get_lastIndex_0(this.a17_1));
  this.b17_1 = true;
  return r;
};
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
function MapEntry(key, value) {
  this.u17_1 = key;
  this.v17_1 = value;
}
protoOf(MapEntry).v = function () {
  return this.u17_1;
};
protoOf(MapEntry).w = function () {
  return this.v17_1;
};
protoOf(MapEntry).toString = function () {
  return 'MapEntry(key=' + toString_0(this.u17_1) + ', value=' + toString_0(this.v17_1) + ')';
};
protoOf(MapEntry).hashCode = function () {
  var result = this.u17_1 == null ? 0 : hashCode(this.u17_1);
  result = imul(result, 31) + (this.v17_1 == null ? 0 : hashCode(this.v17_1)) | 0;
  return result;
};
protoOf(MapEntry).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MapEntry))
    return false;
  var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
  if (!equals(this.u17_1, tmp0_other_with_cast.u17_1))
    return false;
  if (!equals(this.v17_1, tmp0_other_with_cast.v17_1))
    return false;
  return true;
};
function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.tp('key', $keySerializer.fp());
    $this$buildSerialDescriptor.tp('value', $valueSerializer.fp());
    return Unit_instance;
  };
}
function MapEntrySerializer_0(keySerializer, valueSerializer) {
  KeyValueSerializer.call(this, keySerializer, valueSerializer);
  var tmp = this;
  var tmp_0 = MAP_getInstance();
  tmp.y17_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
}
protoOf(MapEntrySerializer_0).fp = function () {
  return this.y17_1;
};
protoOf(MapEntrySerializer_0).z17 = function (_this__u8e3s4) {
  return _this__u8e3s4.v();
};
protoOf(MapEntrySerializer_0).a18 = function (_this__u8e3s4) {
  return this.z17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(MapEntrySerializer_0).b18 = function (_this__u8e3s4) {
  return _this__u8e3s4.w();
};
protoOf(MapEntrySerializer_0).c18 = function (_this__u8e3s4) {
  return this.b18((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
};
protoOf(MapEntrySerializer_0).d18 = function (key, value) {
  return new MapEntry(key, value);
};
function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
  return function ($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.tp('first', $keySerializer.fp());
    $this$buildClassSerialDescriptor.tp('second', $valueSerializer.fp());
    return Unit_instance;
  };
}
function PairSerializer_0(keySerializer, valueSerializer) {
  KeyValueSerializer.call(this, keySerializer, valueSerializer);
  var tmp = this;
  tmp.j18_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
}
protoOf(PairSerializer_0).fp = function () {
  return this.j18_1;
};
protoOf(PairSerializer_0).k18 = function (_this__u8e3s4) {
  return _this__u8e3s4.uf_1;
};
protoOf(PairSerializer_0).a18 = function (_this__u8e3s4) {
  return this.k18(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PairSerializer_0).l18 = function (_this__u8e3s4) {
  return _this__u8e3s4.vf_1;
};
protoOf(PairSerializer_0).c18 = function (_this__u8e3s4) {
  return this.l18(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
};
protoOf(PairSerializer_0).d18 = function (key, value) {
  return to(key, value);
};
function decodeSequentially_1($this, composite) {
  var a = composite.ft($this.p18_1, 0, $this.m18_1);
  var b = composite.ft($this.p18_1, 1, $this.n18_1);
  var c = composite.ft($this.p18_1, 2, $this.o18_1);
  composite.ts($this.p18_1);
  return new Triple(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.jt($this.p18_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.ft($this.p18_1, 0, $this.m18_1);
        break;
      case 1:
        b = composite.ft($this.p18_1, 1, $this.n18_1);
        break;
      case 2:
        c = composite.ft($this.p18_1, 2, $this.o18_1);
        break;
      default:
        throw SerializationException_init_$Create$_0('Unexpected index ' + index);
    }
  }
  composite.ts($this.p18_1);
  if (a === get_NULL())
    throw SerializationException_init_$Create$_0("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException_init_$Create$_0("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException_init_$Create$_0("Element 'third' is missing");
  var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
  var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
  return new Triple(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
}
function TripleSerializer$descriptor$lambda(this$0) {
  return function ($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.tp('first', this$0.m18_1.fp());
    $this$buildClassSerialDescriptor.tp('second', this$0.n18_1.fp());
    $this$buildClassSerialDescriptor.tp('third', this$0.o18_1.fp());
    return Unit_instance;
  };
}
function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
  this.m18_1 = aSerializer;
  this.n18_1 = bSerializer;
  this.o18_1 = cSerializer;
  var tmp = this;
  tmp.p18_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
}
protoOf(TripleSerializer_0).fp = function () {
  return this.p18_1;
};
protoOf(TripleSerializer_0).q18 = function (encoder, value) {
  var structuredEncoder = encoder.ss(this.p18_1);
  structuredEncoder.ju(this.p18_1, 0, this.m18_1, value.fn_1);
  structuredEncoder.ju(this.p18_1, 1, this.n18_1, value.gn_1);
  structuredEncoder.ju(this.p18_1, 2, this.o18_1, value.hn_1);
  structuredEncoder.ts(this.p18_1);
};
protoOf(TripleSerializer_0).gp = function (encoder, value) {
  return this.q18(encoder, value instanceof Triple ? value : THROW_CCE());
};
protoOf(TripleSerializer_0).hp = function (decoder) {
  var composite = decoder.ss(this.p18_1);
  if (composite.it()) {
    return decodeSequentially_1(this, composite);
  }
  return decodeStructure(this, composite);
};
function KeyValueSerializer(keySerializer, valueSerializer) {
  this.e18_1 = keySerializer;
  this.f18_1 = valueSerializer;
}
protoOf(KeyValueSerializer).g18 = function (encoder, value) {
  var structuredEncoder = encoder.ss(this.fp());
  structuredEncoder.ju(this.fp(), 0, this.e18_1, this.a18(value));
  structuredEncoder.ju(this.fp(), 1, this.f18_1, this.c18(value));
  structuredEncoder.ts(this.fp());
};
protoOf(KeyValueSerializer).gp = function (encoder, value) {
  return this.g18(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
};
protoOf(KeyValueSerializer).hp = function (decoder) {
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.fp();
  var composite = decoder.ss(descriptor);
  var tmp$ret$0;
  $l$block: {
    if (composite.it()) {
      var key = composite.ft(this.fp(), 0, this.e18_1);
      var value = composite.ft(this.fp(), 1, this.f18_1);
      tmp$ret$0 = this.d18(key, value);
      break $l$block;
    }
    var key_0 = get_NULL();
    var value_0 = get_NULL();
    mainLoop: while (true) {
      var idx = composite.jt(this.fp());
      switch (idx) {
        case -1:
          break mainLoop;
        case 0:
          key_0 = composite.ft(this.fp(), 0, this.e18_1);
          break;
        case 1:
          value_0 = composite.ft(this.fp(), 1, this.f18_1);
          break;
        default:
          throw SerializationException_init_$Create$_0('Invalid index: ' + idx);
      }
    }
    if (key_0 === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'key' is missing");
    if (value_0 === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'value' is missing");
    var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
    tmp$ret$0 = this.d18(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
  }
  var result = tmp$ret$0;
  composite.ts(descriptor);
  return result;
};
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
function ULongSerializer() {
  ULongSerializer_instance = this;
  this.r18_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_7(Companion_instance));
}
protoOf(ULongSerializer).fp = function () {
  return this.r18_1;
};
protoOf(ULongSerializer).s18 = function (encoder, value) {
  var tmp = encoder.yt(this.r18_1);
  // Inline function 'kotlin.ULong.toLong' call
  var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
  tmp.st(tmp$ret$0);
};
protoOf(ULongSerializer).gp = function (encoder, value) {
  return this.s18(encoder, value instanceof ULong ? value.no_1 : THROW_CCE());
};
protoOf(ULongSerializer).t18 = function (decoder) {
  // Inline function 'kotlin.toULong' call
  var this_0 = decoder.ps(this.r18_1).js();
  return _ULong___init__impl__c78o9k(this_0);
};
protoOf(ULongSerializer).hp = function (decoder) {
  return new ULong(this.t18(decoder));
};
var ULongSerializer_instance;
function ULongSerializer_getInstance() {
  if (ULongSerializer_instance == null)
    new ULongSerializer();
  return ULongSerializer_instance;
}
function UIntSerializer() {
  UIntSerializer_instance = this;
  this.u18_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_8(IntCompanionObject_instance));
}
protoOf(UIntSerializer).fp = function () {
  return this.u18_1;
};
protoOf(UIntSerializer).v18 = function (encoder, value) {
  var tmp = encoder.yt(this.u18_1);
  // Inline function 'kotlin.UInt.toInt' call
  var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
  tmp.rt(tmp$ret$0);
};
protoOf(UIntSerializer).gp = function (encoder, value) {
  return this.v18(encoder, value instanceof UInt ? value.co_1 : THROW_CCE());
};
protoOf(UIntSerializer).w18 = function (decoder) {
  // Inline function 'kotlin.toUInt' call
  var this_0 = decoder.ps(this.u18_1).is();
  return _UInt___init__impl__l7qpdl(this_0);
};
protoOf(UIntSerializer).hp = function (decoder) {
  return new UInt(this.w18(decoder));
};
var UIntSerializer_instance;
function UIntSerializer_getInstance() {
  if (UIntSerializer_instance == null)
    new UIntSerializer();
  return UIntSerializer_instance;
}
function UByteSerializer() {
  UByteSerializer_instance = this;
  this.x18_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_9(ByteCompanionObject_instance));
}
protoOf(UByteSerializer).fp = function () {
  return this.x18_1;
};
protoOf(UByteSerializer).y18 = function (encoder, value) {
  var tmp = encoder.yt(this.x18_1);
  // Inline function 'kotlin.UByte.toByte' call
  var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
  tmp.pt(tmp$ret$0);
};
protoOf(UByteSerializer).gp = function (encoder, value) {
  return this.y18(encoder, value instanceof UByte ? value.rn_1 : THROW_CCE());
};
protoOf(UByteSerializer).z18 = function (decoder) {
  // Inline function 'kotlin.toUByte' call
  var this_0 = decoder.ps(this.x18_1).gs();
  return _UByte___init__impl__g9hnc4(this_0);
};
protoOf(UByteSerializer).hp = function (decoder) {
  return new UByte(this.z18(decoder));
};
var UByteSerializer_instance;
function UByteSerializer_getInstance() {
  if (UByteSerializer_instance == null)
    new UByteSerializer();
  return UByteSerializer_instance;
}
function UShortSerializer() {
  UShortSerializer_instance = this;
  this.a19_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_10(ShortCompanionObject_instance));
}
protoOf(UShortSerializer).fp = function () {
  return this.a19_1;
};
protoOf(UShortSerializer).b19 = function (encoder, value) {
  var tmp = encoder.yt(this.a19_1);
  // Inline function 'kotlin.UShort.toShort' call
  var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
  tmp.qt(tmp$ret$0);
};
protoOf(UShortSerializer).gp = function (encoder, value) {
  return this.b19(encoder, value instanceof UShort ? value.yo_1 : THROW_CCE());
};
protoOf(UShortSerializer).c19 = function (decoder) {
  // Inline function 'kotlin.toUShort' call
  var this_0 = decoder.ps(this.a19_1).hs();
  return _UShort___init__impl__jigrne(this_0);
};
protoOf(UShortSerializer).hp = function (decoder) {
  return new UShort(this.c19(decoder));
};
var UShortSerializer_instance;
function UShortSerializer_getInstance() {
  if (UShortSerializer_instance == null)
    new UShortSerializer();
  return UShortSerializer_instance;
}
function get_EmptySerializersModuleLegacyJs() {
  _init_properties_SerializersModule_kt__u78ha3();
  return EmptySerializersModule;
}
var EmptySerializersModule;
function SerializersModule() {
}
protoOf(SerializersModule).oq = function (kClass, typeArgumentsSerializers, $super) {
  typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
  return $super === VOID ? this.pq(kClass, typeArgumentsSerializers) : $super.pq.call(this, kClass, typeArgumentsSerializers);
};
function SerialModuleImpl(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider, hasInterfaceContextualSerializers) {
  SerializersModule.call(this);
  this.e19_1 = class2ContextualFactory;
  this.f19_1 = polyBase2Serializers;
  this.g19_1 = polyBase2DefaultSerializerProvider;
  this.h19_1 = polyBase2NamedSerializers;
  this.i19_1 = polyBase2DefaultDeserializerProvider;
  this.j19_1 = hasInterfaceContextualSerializers;
}
protoOf(SerialModuleImpl).nq = function () {
  return this.j19_1;
};
protoOf(SerialModuleImpl).ru = function (baseClass, value) {
  if (!baseClass.fa(value))
    return null;
  var tmp0_safe_receiver = this.f19_1.h2(baseClass);
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h2(getKClassFromExpression(value));
  var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
  if (!(registered == null))
    return registered;
  var tmp_0 = this.g19_1.h2(baseClass);
  var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
};
protoOf(SerialModuleImpl).qu = function (baseClass, serializedClassName) {
  var tmp0_safe_receiver = this.h19_1.h2(baseClass);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.get' call
    tmp = (isInterface(tmp0_safe_receiver, KtMap) ? tmp0_safe_receiver : THROW_CCE()).h2(serializedClassName);
  }
  var tmp_0 = tmp;
  var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
  if (!(registered == null))
    return registered;
  var tmp_1 = this.i19_1.h2(baseClass);
  var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
};
protoOf(SerialModuleImpl).pq = function (kClass, typeArgumentsSerializers) {
  var tmp0_safe_receiver = this.e19_1.h2(kClass);
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k19(typeArgumentsSerializers);
  return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
};
protoOf(SerialModuleImpl).d19 = function (collector) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = this.e19_1.u().l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    // Inline function 'kotlin.collections.component1' call
    var kclass = element.v();
    // Inline function 'kotlin.collections.component2' call
    var serial = element.w();
    if (serial instanceof Argless) {
      var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
      var tmp_0 = serial.n19_1;
      collector.o19(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
    } else {
      if (serial instanceof WithTypeArguments) {
        collector.m19(kclass, serial.l19_1);
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = this.f19_1.u().l();
  while (_iterator__ex2g4s_0.m()) {
    var element_0 = _iterator__ex2g4s_0.n();
    // Inline function 'kotlin.collections.component1' call
    var baseClass = element_0.v();
    // Inline function 'kotlin.collections.component2' call
    var classMap = element_0.w();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_1 = classMap.u().l();
    while (_iterator__ex2g4s_1.m()) {
      var element_1 = _iterator__ex2g4s_1.n();
      // Inline function 'kotlin.collections.component1' call
      var actualClass = element_1.v();
      // Inline function 'kotlin.collections.component2' call
      var serializer = element_1.w();
      var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
      var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var tmp$ret$11 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
      collector.p19(tmp_1, tmp_2, tmp$ret$11);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_2 = this.g19_1.u().l();
  while (_iterator__ex2g4s_2.m()) {
    var element_2 = _iterator__ex2g4s_2.n();
    // Inline function 'kotlin.collections.component1' call
    var baseClass_0 = element_2.v();
    // Inline function 'kotlin.collections.component2' call
    var provider = element_2.w();
    var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
    collector.q19(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_3 = this.i19_1.u().l();
  while (_iterator__ex2g4s_3.m()) {
    var element_3 = _iterator__ex2g4s_3.n();
    // Inline function 'kotlin.collections.component1' call
    var baseClass_1 = element_3.v();
    // Inline function 'kotlin.collections.component2' call
    var provider_0 = element_3.w();
    var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
    collector.r19(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
  }
};
function Argless() {
}
function WithTypeArguments() {
}
function ContextualProvider() {
}
var properties_initialized_SerializersModule_kt_fjigjn;
function _init_properties_SerializersModule_kt__u78ha3() {
  if (!properties_initialized_SerializersModule_kt_fjigjn) {
    properties_initialized_SerializersModule_kt_fjigjn = true;
    EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap(), false);
  }
}
function EmptySerializersModule_0() {
  return get_EmptySerializersModuleLegacyJs();
}
function SerializersModuleCollector$contextual$lambda($serializer) {
  return function (it) {
    return $serializer;
  };
}
function SerializersModuleCollector() {
}
function SerializableWith(serializer) {
  this.s19_1 = serializer;
}
protoOf(SerializableWith).equals = function (other) {
  if (!(other instanceof SerializableWith))
    return false;
  var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
  if (!this.s19_1.equals(tmp0_other_with_cast.s19_1))
    return false;
  return true;
};
protoOf(SerializableWith).hashCode = function () {
  return imul(getStringHashCode('serializer'), 127) ^ this.s19_1.hashCode();
};
protoOf(SerializableWith).toString = function () {
  return '@kotlinx.serialization.SerializableWith(' + 'serializer=' + toString(this.s19_1) + ')';
};
function compiledSerializerImpl(_this__u8e3s4) {
  var tmp0_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (_this__u8e3s4 === PrimitiveClasses_getInstance().cb()) {
      tmp_0 = NothingSerializer_getInstance();
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp1_safe_receiver = get_js(_this__u8e3s4).Companion;
      tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.serializer();
    }
    var tmp_1 = tmp_0;
    tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer) : false) ? tmp_1 : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
  throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4) + 'To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.');
}
function isInterface_0(_this__u8e3s4) {
  return get_isInterfaceHack(_this__u8e3s4);
}
function isReferenceArray(rootClass) {
  return rootClass.equals(PrimitiveClasses_getInstance().kb());
}
function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
  var tmp;
  try {
    // Inline function 'kotlin.reflect.findAssociatedObject' call
    var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
    var tmp_0;
    if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
      tmp_0 = isInterface(assocObject, KSerializer) ? assocObject : THROW_CCE();
    } else {
      if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
        var tmp_1 = assocObject.k11(args.slice());
        tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
      } else {
        tmp_0 = null;
      }
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_2;
    var e = $p;
    tmp_2 = null;
    tmp = tmp_2;
  }
  return tmp;
}
function createCache(factory) {
  return new createCache$1(factory);
}
function createParametrizedCache(factory) {
  return new createParametrizedCache$1(factory);
}
function getChecked(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
function getChecked_0(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
function toNativeArrayImpl(_this__u8e3s4, eClass) {
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(_this__u8e3s4);
}
function initBuiltins() {
  return mapOf([to(PrimitiveClasses_getInstance().lb(), serializer_2(StringCompanionObject_instance)), to(getKClass(Char), serializer_11(Companion_getInstance_2())), to(PrimitiveClasses_getInstance().ob(), CharArraySerializer()), to(PrimitiveClasses_getInstance().jb(), serializer_12(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().ub(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance().ib(), serializer_13(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().tb(), FloatArraySerializer()), to(PrimitiveClasses_getInstance().hb(), serializer_7(Companion_instance)), to(PrimitiveClasses_getInstance().sb(), LongArraySerializer()), to(getKClass(ULong), serializer_3(Companion_getInstance_3())), to(getKClass(ULongArray), ULongArraySerializer()), to(PrimitiveClasses_getInstance().gb(), serializer_8(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().rb(), IntArraySerializer()), to(getKClass(UInt), serializer_4(Companion_getInstance_4())), to(getKClass(UIntArray), UIntArraySerializer()), to(PrimitiveClasses_getInstance().fb(), serializer_10(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().qb(), ShortArraySerializer()), to(getKClass(UShort), serializer_6(Companion_getInstance_5())), to(getKClass(UShortArray), UShortArraySerializer()), to(PrimitiveClasses_getInstance().eb(), serializer_9(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().pb(), ByteArraySerializer()), to(getKClass(UByte), serializer_5(Companion_getInstance_6())), to(getKClass(UByteArray), UByteArraySerializer()), to(PrimitiveClasses_getInstance().db(), serializer_14(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().nb(), BooleanArraySerializer()), to(getKClass(Unit), serializer_15(Unit_instance)), to(PrimitiveClasses_getInstance().cb(), NothingSerializer()), to(getKClass(Duration), serializer_16(Companion_getInstance())), to(getKClass(Instant), serializer_17(Companion_getInstance_0())), to(getKClass(Uuid), serializer_18(Companion_getInstance_1()))]);
}
function get_isInterfaceHack(_this__u8e3s4) {
  if (_this__u8e3s4 === PrimitiveClasses_getInstance().cb())
    return false;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
  return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
}
function createCache$1($factory) {
  this.t19_1 = $factory;
}
protoOf(createCache$1).qq = function (key) {
  return this.t19_1(key);
};
function createParametrizedCache$1($factory) {
  this.u19_1 = $factory;
}
protoOf(createParametrizedCache$1).rq = function (key, types) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = this.u19_1(key, types);
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
};
//region block: post-declaration
protoOf(SerialDescriptorImpl).sq = get_isNullable;
protoOf(SerialDescriptorImpl).ar = get_isInline;
protoOf(AbstractDecoder).ft = decodeSerializableElement$default;
protoOf(AbstractDecoder).rs = decodeSerializableValue;
protoOf(AbstractDecoder).it = decodeSequentially;
protoOf(AbstractDecoder).kt = decodeCollectionSize;
protoOf(AbstractEncoder).nu = encodeNotNullMark;
protoOf(AbstractEncoder).ou = beginCollection;
protoOf(AbstractEncoder).ku = encodeSerializableValue;
protoOf(AbstractEncoder).mu = encodeNullableSerializableValue;
protoOf(AbstractEncoder).pu = shouldEncodeElementDefault;
protoOf(ListLikeDescriptor).sq = get_isNullable;
protoOf(ListLikeDescriptor).ar = get_isInline;
protoOf(ListLikeDescriptor).cr = get_annotations;
protoOf(MapLikeDescriptor).sq = get_isNullable;
protoOf(MapLikeDescriptor).ar = get_isInline;
protoOf(MapLikeDescriptor).cr = get_annotations;
protoOf(PluginGeneratedSerialDescriptor).sq = get_isNullable;
protoOf(PluginGeneratedSerialDescriptor).ar = get_isInline;
protoOf(InlinePrimitiveDescriptor$1).a11 = typeParametersSerializers;
protoOf(NothingSerialDescriptor).sq = get_isNullable;
protoOf(NothingSerialDescriptor).ar = get_isInline;
protoOf(NothingSerialDescriptor).cr = get_annotations;
protoOf(PrimitiveSerialDescriptor_0).sq = get_isNullable;
protoOf(PrimitiveSerialDescriptor_0).ar = get_isInline;
protoOf(PrimitiveSerialDescriptor_0).cr = get_annotations;
protoOf(TaggedDecoder).ft = decodeSerializableElement$default;
protoOf(TaggedDecoder).rs = decodeSerializableValue;
protoOf(TaggedDecoder).it = decodeSequentially;
protoOf(TaggedDecoder).kt = decodeCollectionSize;
//endregion
//region block: exports
export {
  MissingFieldException_init_$Create$_0 as MissingFieldException_init_$Create$8e88b5fk0hk1,
  SerializationException_init_$Init$_0 as SerializationException_init_$Init$nhp5tm45z5re,
  SerializationException_init_$Create$_0 as SerializationException_init_$Create$1b97dv9p64p50,
  UnknownFieldException_init_$Create$ as UnknownFieldException_init_$Create$hprktcyan42n,
  SEALED_getInstance as SEALED_getInstance3nsev85ow9059,
  INT_getInstance as INT_getInstancev41irj55hx3n,
  STRING_getInstance as STRING_getInstance2ou4lro9xn2qn,
  CONTEXTUAL_getInstance as CONTEXTUAL_getInstance1845118lbzky0,
  ENUM_getInstance as ENUM_getInstance22lfbrqor0c0a,
  CLASS_getInstance as CLASS_getInstance14ex35co4jkrb,
  LIST_getInstance as LIST_getInstancey7k5h8d5cvxt,
  MAP_getInstance as MAP_getInstance3s1t6byguxmp9,
  OBJECT_getInstance as OBJECT_getInstance26229tfe4t547,
  BooleanSerializer_getInstance as BooleanSerializer_getInstance1t8habeqgiyq1,
  DoubleSerializer_getInstance as DoubleSerializer_getInstance3da4hv5ndgjlx,
  FloatSerializer_getInstance as FloatSerializer_getInstance2fspe61zbqree,
  IntSerializer_getInstance as IntSerializer_getInstance2q7s8kvk1il5u,
  LongSerializer_getInstance as LongSerializer_getInstance194e4t3ow5wjs,
  StringSerializer_getInstance as StringSerializer_getInstance2wffkbpdux3h9,
  ListSerializer as ListSerializer1hxuk9dx5n9du,
  MapSerializer as MapSerializer11kmegt3g5c1g,
  SetSerializer as SetSerializert3lb0yy9iftr,
  get_nullable as get_nullable197rfua9r7fsz,
  serializer_2 as serializer1x79l67jvwntn,
  serializer_6 as serializer1q7c5q67ysppr,
  serializer_4 as serializer3ikrxnm8b29d6,
  serializer_5 as serializer36584sjyg5661,
  serializer_3 as serializer2lw83vwvpnyms,
  PolymorphicKind as PolymorphicKindla9gurooefwb,
  PrimitiveKind as PrimitiveKindndgbuh6is7ze,
  PrimitiveSerialDescriptor as PrimitiveSerialDescriptor3egfp53lutxj2,
  get_annotations as get_annotationshjxdbdcl8kmv,
  get_isInline as get_isInline5x26qrhi9qs6,
  get_isNullable as get_isNullable36pbikm8xb7bz,
  SerialDescriptor as SerialDescriptor2pelqekb5ic3a,
  ENUM as ENUMlmq49cvwy4ow,
  buildClassSerialDescriptor as buildClassSerialDescriptors2a6xdp6mrtw,
  buildSerialDescriptor as buildSerialDescriptor2873qmkp8r2ib,
  get_elementDescriptors as get_elementDescriptors13xxljc24xo44,
  getContextualDescriptor as getContextualDescriptor2n1gf3b895yb8,
  AbstractDecoder as AbstractDecoder35guh02ubh2hm,
  AbstractEncoder as AbstractEncoder2gxtu3xmy3f8j,
  CompositeDecoder as CompositeDecoder2tzm7wpwkr0og,
  CompositeEncoder as CompositeEncoderknecpkexzn3v,
  Decoder as Decoder23nde051s631g,
  Encoder as Encoderqvmrpqtq8hnu,
  AbstractPolymorphicSerializer as AbstractPolymorphicSerializer1ccxwp48nfy58,
  ArrayListSerializer as ArrayListSerializer7k5wnrulb3y6,
  ElementMarker as ElementMarker33ojvsajwmzts,
  typeParametersSerializers as typeParametersSerializers2likxjr48tr7y,
  GeneratedSerializer as GeneratedSerializer1f7t7hssdd2ws,
  InlinePrimitiveDescriptor as InlinePrimitiveDescriptor3i6ccn1a4fw94,
  LinkedHashMapSerializer as LinkedHashMapSerializermaoj2nyji7op,
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
  PluginGeneratedSerialDescriptor as PluginGeneratedSerialDescriptorqdzeg5asqhfg,
  SerializerFactory as SerializerFactory1qv9hivitncuv,
  createAnnotatedEnumSerializer as createAnnotatedEnumSerializer20ay4pme9p2h9,
  createSimpleEnumSerializer as createSimpleEnumSerializer2guioz11kk1m0,
  jsonCachedSerialNames as jsonCachedSerialNameslxufy2gu43jt,
  throwMissingFieldException as throwMissingFieldException2cmke0v3ynf14,
  EmptySerializersModule_0 as EmptySerializersModule991ju6pz9b79,
  contextual as contextual3hpp1gupsu4al,
  SerializersModuleCollector as SerializersModuleCollector3dddz14wd7brg,
  BinaryFormat as BinaryFormat3f3aelhmz0ro1,
  DeserializationStrategy as DeserializationStrategy1z3z5pj9f7zc8,
  KSerializer as KSerializerzf77vz1967fq,
  MissingFieldException as MissingFieldException24tqif29emcmi,
  SealedClassSerializer as SealedClassSerializeriwipiibk55zc,
  SerializationException as SerializationExceptioneqrdve3ts2n9,
  SerializationStrategy as SerializationStrategyh6ouydnm6hci,
  StringFormat as StringFormat2r2ka8mzcb3mi,
  findPolymorphicSerializer as findPolymorphicSerializer1nm87hvemahcj,
  findPolymorphicSerializer_0 as findPolymorphicSerializerk638ixyjovk5,
  serializerOrNull_0 as serializerOrNull31x2b6nu6gruj,
  serializerOrNull as serializerOrNull294cbc318ws50,
  serializer_0 as serializer1hwzc6m64v1op,
  serializer_1 as serializer1rka18p0rjk4x,
  serializer as serializer1i4e9ym37oxmo,
};
//endregion

//# sourceMappingURL=kotlinx-serialization-kotlinx-serialization-core.mjs.map
